import React from 'react';
import {useTheme} from '@material-ui/core/styles';

export const ActiveListening = props => {
	return (
		<svg id='ActiveListening' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 48 48'}>
			<defs>
				<style>{`
					svg#ActiveListening .cls-1{fill:${props.color};}
					svg#ActiveListening .cls-2{fill:none;stroke:${props.color};stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}'}
				`}</style>
			</defs>

			<path className="cls-1" d="M35.93,12.43a1.4,1.4,0,0,0-2.18-.33l-.09.1a1.36,1.36,0,0,0-.29,1.7,4.84,4.84,0,0,1,0,4.74,1.36,1.36,0,0,0,.29,1.7l.09.1a1.39,1.39,0,0,0,2.18-.33,7.66,7.66,0,0,0,1-3.84A7.4,7.4,0,0,0,35.93,12.43Z" />
			<path className="cls-1" d="M39.63,9a1.44,1.44,0,0,0-2.14-.24l-.09.09a1.45,1.45,0,0,0-.19,1.9,9.95,9.95,0,0,1,0,11.27,1.45,1.45,0,0,0,.19,1.9l.09.09a1.44,1.44,0,0,0,2.14-.23A12.93,12.93,0,0,0,39.63,9Z" />
			<path className="cls-1" d="M43.32,5.57a1.4,1.4,0,0,0-2.08-.19l-.1.09A1.4,1.4,0,0,0,41,7.41a14.65,14.65,0,0,1,3,8.91,14.88,14.88,0,0,1-3,8.9,1.47,1.47,0,0,0,.14,2l.1.09a1.41,1.41,0,0,0,2.08-.19,17.85,17.85,0,0,0,0-21.5Z" />
			<path className="cls-1" d="M15.94,3.43a14.05,14.05,0,0,0-14,14,1.57,1.57,0,0,0,3.13,0A10.9,10.9,0,0,1,15.94,6.56c6.54,0,10.61,4,10.61,10.33,0,2.55-1.51,4.59-3.12,6.72s-3.22,4.27-3.56,7.16c-.61,5.4-2.7,11.13-6.58,11.13S7.7,38.72,7.7,35.6A1.58,1.58,0,0,0,6.14,34,1.54,1.54,0,0,0,4.62,35.6c0,4.69,3,9.42,8.72,9.42,5,0,8.67-5.21,9.66-13.92.24-2,1.56-3.79,2.94-5.64,1.75-2.32,3.74-5,3.74-8.57C29.68,8.83,24.18,3.43,15.94,3.43Z" />
			<path className="cls-2" d="M22,17.41S21.83,11,15.8,11c-5.51,0-7.78,6.66-4.43,12.2A13.45,13.45,0,0,1,13,33.79" />
		</svg>
	);
};

export const Adaptability = props => {
	return (
		<svg id='Adaptability' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 48 48'}>
			<defs>
				<style>{`
					svg#Adaptability .cls-1{fill:${props.color};}
					svg#Adaptability .cls-2{fill:none;stroke:${props.color};stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}
				`}</style>
			</defs>

			<path className="cls-1" d="M44.83,22.38H43.17V19.14a1.61,1.61,0,0,0-.88-1.42,1.73,1.73,0,0,0-1.72.08l-7.5,4.85a1.59,1.59,0,0,0,0,2.69l7.5,4.85a1.68,1.68,0,0,0,.92.27,1.84,1.84,0,0,0,.79-.19,1.63,1.63,0,0,0,.88-1.43V25.61h1.66a1.62,1.62,0,1,0,0-3.23Z" />
			<path className="cls-1" d="M15.67,24a1.59,1.59,0,0,0-.75-1.34L7.42,17.8a1.71,1.71,0,0,0-1.71-.08,1.61,1.61,0,0,0-.88,1.42v3.24H3.17a1.62,1.62,0,1,0,0,3.23H4.83v3.23a1.63,1.63,0,0,0,.88,1.43,1.84,1.84,0,0,0,.79.19,1.68,1.68,0,0,0,.92-.27l7.5-4.85A1.61,1.61,0,0,0,15.67,24Z" />
			<path className="cls-2" d="M12.72,3s13.31,18.41,0,42" />
			<path className="cls-2" d="M34.46,3s-13.31,18.41,0,42" />
			<line className="cls-2" x1="24" y1="2.98" x2="24" y2="45" />
		</svg>
	);
};

export const Anchoring = props => {
	return (
		<svg id='Anchoring' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 48 48'}>
			<defs>
				<style>{`
					svg#Anchoring .st0{fill:${props.color};}
				`}</style>
			</defs>

			<g>
				<g>
					<g>
						<path className="st0" d="M43.36,29.1l-2.84-2.84c-0.74-0.75-2.03-0.77-2.82,0l-2.84,2.84c-0.38,0.38-0.59,0.88-0.59,1.43
				c0,0.53,0.21,1.03,0.59,1.4c0.44,0.45,1.1,0.66,1.73,0.55c-1.35,5.03-5.64,8.85-10.83,9.59V24.59h5.9c1.1,0,1.99-0.9,1.99-2
				s-0.89-2-1.99-2h-5.9v-2.46c3.66-0.9,6.28-4.21,6.28-8.03c0-4.57-3.71-8.28-8.28-8.28c-4.56,0-8.27,3.71-8.27,8.28
				c0,3.82,2.62,7.13,6.28,8.03v2.46h-5.91c-1.1,0-1.99,0.9-1.99,2s0.89,2,1.99,2h5.91v17.42c-5.02-0.86-9.16-4.65-10.48-9.55
				c0.65,0.15,1.38-0.06,1.86-0.53c0.76-0.77,0.76-2.04-0.01-2.83l-2.85-2.84c-0.76-0.77-2.06-0.75-2.81,0L4.63,29.1
				c-0.38,0.37-0.59,0.88-0.59,1.44c0.01,0.54,0.22,1.03,0.59,1.39c0.64,0.64,1.72,0.76,2.5,0.26c1.43,7.95,8.14,13.75,16.32,13.98
				l0.48,0.01c8.3,0,15.37-5.98,16.83-14.06c0.76,0.56,1.93,0.48,2.6-0.18c0.37-0.36,0.59-0.86,0.6-1.41
				C43.96,30,43.74,29.48,43.36,29.1z M23.2,14.02c-0.35,0-0.67-0.11-0.91-0.32l-2.07-1.59c-0.31-0.25-0.51-0.6-0.55-0.98
				c-0.05-0.37,0.05-0.75,0.28-1.06c0.25-0.33,0.6-0.52,0.99-0.56c0.03-0.02,0.11-0.02,0.17-0.02c0.31,0,0.62,0.11,0.89,0.31
				l0.94,0.73L25.3,7.5c0.25-0.31,0.58-0.5,0.96-0.55c0.04-0.01,0.12-0.01,0.19-0.01c0.33,0,0.64,0.11,0.89,0.31
				c0.64,0.49,0.76,1.39,0.26,2.04l-3.25,4.18C24.06,13.82,23.64,14.02,23.2,14.02z"/>
					</g>
				</g>
			</g>
		</svg>
	);
};

export const BasicCarpentry = props => {
	return (
		<svg id='BasicCarpentry' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 48 48'}>
			<defs>
				<style>{`
					svg#BasicCarpentry .st0{fill:${props.color};}
					svg#BasicCarpentry .st1{fill:none;stroke:${props.color};stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}
					svg#BasicCarpentry .st2{fill:#264254;}
					svg#BasicCarpentry .st3{fill:none;stroke:${props.color};stroke-width:3;stroke-miterlimit:10;}
				`}</style>
			</defs>

			<g>
				<g>
					<g>
						<path className="st0" d="M-113.11,40.75l-2.84-2.84c-0.74-0.75-2.03-0.77-2.82,0l-2.84,2.84c-0.38,0.38-0.59,0.88-0.59,1.43
				c0,0.53,0.21,1.03,0.59,1.4c0.44,0.45,1.1,0.66,1.73,0.55c-1.35,5.03-5.64,8.85-10.83,9.59V36.24h5.9c1.1,0,1.99-0.9,1.99-2
				c0-1.1-0.89-2-1.99-2h-5.9v-2.46c3.66-0.9,6.28-4.21,6.28-8.03c0-4.57-3.71-8.28-8.28-8.28c-4.56,0-8.27,3.71-8.27,8.28
				c0,3.82,2.62,7.13,6.28,8.03v2.46h-5.91c-1.1,0-1.99,0.9-1.99,2c0,1.1,0.89,2,1.99,2h5.91v17.42c-5.02-0.86-9.16-4.65-10.48-9.55
				c0.65,0.15,1.38-0.06,1.86-0.53c0.76-0.77,0.76-2.04-0.01-2.83l-2.85-2.84c-0.76-0.77-2.06-0.75-2.81,0l-2.85,2.84
				c-0.38,0.37-0.59,0.88-0.59,1.44c0.01,0.54,0.22,1.03,0.59,1.39c0.64,0.64,1.72,0.76,2.5,0.26c1.43,7.95,8.14,13.75,16.32,13.98
				l0.48,0.01c8.3,0,15.37-5.98,16.83-14.06c0.76,0.56,1.93,0.48,2.6-0.18c0.37-0.36,0.59-0.86,0.6-1.41
				C-112.51,41.65-112.73,41.13-113.11,40.75z M-133.27,25.67c-0.35,0-0.67-0.11-0.91-0.32l-2.07-1.59
				c-0.31-0.25-0.51-0.6-0.55-0.98c-0.05-0.37,0.05-0.75,0.28-1.06c0.25-0.33,0.6-0.52,0.99-0.56c0.03-0.02,0.11-0.02,0.17-0.02
				c0.31,0,0.62,0.11,0.89,0.31l0.94,0.73l2.36-3.03c0.25-0.31,0.58-0.5,0.96-0.55c0.04-0.01,0.12-0.01,0.19-0.01
				c0.33,0,0.64,0.11,0.89,0.31c0.64,0.49,0.76,1.39,0.26,2.04l-3.25,4.18C-132.41,25.47-132.83,25.67-133.27,25.67z"/>
					</g>
				</g>
			</g>
			<g>
				<g>
					<g>
						<path className="st0" d="M-113.11-15.19l-2.84-2.84c-0.74-0.75-2.03-0.77-2.82,0l-2.84,2.84c-0.38,0.38-0.59,0.88-0.59,1.43
				c0,0.53,0.21,1.03,0.59,1.4c0.44,0.45,1.1,0.66,1.73,0.55c-1.35,5.03-5.64,8.85-10.83,9.59V-19.7h5.9c1.1,0,1.99-0.9,1.99-2
				c0-1.1-0.89-2-1.99-2h-5.9v-2.46c3.66-0.9,6.28-4.21,6.28-8.03c0-4.57-3.71-8.28-8.28-8.28c-4.56,0-8.27,3.71-8.27,8.28
				c0,3.82,2.62,7.13,6.28,8.03v2.46h-5.91c-1.1,0-1.99,0.9-1.99,2c0,1.1,0.89,2,1.99,2h5.91v17.42c-5.02-0.86-9.16-4.65-10.48-9.55
				c0.65,0.15,1.38-0.06,1.86-0.53c0.76-0.77,0.76-2.04-0.01-2.83l-2.85-2.84c-0.76-0.77-2.06-0.75-2.81,0l-2.85,2.84
				c-0.38,0.37-0.59,0.88-0.59,1.44c0.01,0.54,0.22,1.03,0.59,1.39c0.64,0.64,1.72,0.76,2.5,0.26c1.43,7.95,8.14,13.75,16.32,13.98
				l0.48,0.01c8.3,0,15.37-5.98,16.83-14.06c0.76,0.56,1.93,0.48,2.6-0.18c0.37-0.36,0.59-0.86,0.6-1.41
				C-112.51-14.29-112.73-14.81-113.11-15.19z M-133.27-30.27c-0.35,0-0.67-0.11-0.91-0.32l-2.07-1.59
				c-0.31-0.25-0.51-0.6-0.55-0.98c-0.05-0.37,0.05-0.75,0.28-1.06c0.25-0.33,0.6-0.52,0.99-0.56c0.03-0.02,0.11-0.02,0.17-0.02
				c0.31,0,0.62,0.11,0.89,0.31l0.94,0.73l2.36-3.03c0.25-0.31,0.58-0.5,0.96-0.55c0.04-0.01,0.12-0.01,0.19-0.01
				c0.33,0,0.64,0.11,0.89,0.31c0.64,0.49,0.76,1.39,0.26,2.04l-3.25,4.18C-132.41-30.47-132.83-30.27-133.27-30.27z"/>
					</g>
				</g>
			</g>
			<g>
				<line className="st1" x1="-74.89" y1="-20.29" x2="-92.27" y2="-20.29" />
				<path className="st1" d="M-65.57-12.32v8.39c0,0.93-0.76,1.69-1.69,1.69h-8.93" />
				<path className="st1" d="M-101.79-12.32v8.39c0,0.93,0.76,1.69,1.69,1.69h8.93" />
				<path className="st1" d="M-91.71-38.46h-8.39c-0.93,0-1.69,0.76-1.69,1.69v8.93" />
				<path className="st1" d="M-75.65-38.46h8.39c0.93,0,1.69,0.76,1.69,1.69v8.93" />
			</g>
			<g>
				<g>
					<path className="st0" d="M-74.89,37.71h-17.38c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2h17.38c1.1,0,2,0.9,2,2
			C-72.89,36.81-73.79,37.71-74.89,37.71z"/>
				</g>
				<g>
					<path className="st0" d="M-67.26,55.76h-8.93c-1.1,0-2-0.9-2-2s0.9-2,2-2h8.62v-8.08c0-1.1,0.9-2,2-2s2,0.9,2,2v8.39
			C-63.57,54.1-65.22,55.76-67.26,55.76z"/>
				</g>
				<g>
					<path className="st0" d="M-91.17,55.76h-8.93c-2.04,0-3.69-1.66-3.69-3.69v-8.39c0-1.1,0.9-2,2-2s2,0.9,2,2v8.08h8.62c1.1,0,2,0.9,2,2
			S-90.06,55.76-91.17,55.76z"/>
				</g>
				<g>
					<path className="st0" d="M-101.79,30.16c-1.1,0-2-0.9-2-2v-8.93c0-2.04,1.66-3.69,3.69-3.69h8.39c1.1,0,2,0.9,2,2s-0.9,2-2,2h-8.08
			v8.62C-99.79,29.26-100.69,30.16-101.79,30.16z"/>
				</g>
				<g>
					<path className="st0" d="M-65.57,30.16c-1.1,0-2-0.9-2-2v-8.62h-8.08c-1.1,0-2-0.9-2-2s0.9-2,2-2h8.39c2.04,0,3.69,1.66,3.69,3.69
			v8.93C-63.57,29.26-64.46,30.16-65.57,30.16z M-67.26,19.54L-67.26,19.54L-67.26,19.54z"/>
				</g>
			</g>
			<path className="st0" d="M-47.84-9.4v7.87c0,0.94,1.12,1.43,1.81,0.8l8.28-8.67H-47.84z" />
			<path className="st0" d="M-21.28-40.4h-30.39c-3.41,0-6.17,2.76-6.17,6.17v18.66c0,3.41,2.76,6.17,6.17,6.17h30.39
	c3.41,0,6.17-2.76,6.17-6.17v-18.66C-15.11-37.64-17.87-40.4-21.28-40.4z M-43.57-17.04c-0.36,0.19-0.75,0.28-1.14,0.28
	c-0.9,0-1.77-0.49-2.21-1.35c-0.63-1.22-0.15-2.72,1.07-3.35c1.39-0.72,2.41-1.9,2.96-3.28c-1-0.25-1.91-0.85-2.52-1.78
	c-1.28-1.95-0.73-4.57,1.23-5.85c1.95-1.28,4.57-0.73,5.85,1.23c0.08,0.12,0.13,0.25,0.2,0.38c0.04,0.07,0.08,0.14,0.11,0.22
	c0.05,0.11,0.09,0.22,0.13,0.33c0,0.01,0.01,0.01,0.01,0.02c0,0.01,0.01,0.03,0.01,0.04c0.08,0.24,0.14,0.49,0.17,0.73
	C-36.66-24.48-39.04-19.37-43.57-17.04z M-31.86-17.04c-0.36,0.19-0.75,0.28-1.14,0.28c-0.9,0-1.77-0.49-2.21-1.35
	c-0.63-1.22-0.15-2.72,1.07-3.35c1.39-0.72,2.41-1.9,2.96-3.28c-1-0.25-1.91-0.85-2.52-1.78c-1.28-1.95-0.73-4.57,1.23-5.85
	c1.95-1.28,4.57-0.73,5.85,1.23c0.08,0.12,0.13,0.25,0.2,0.38c0.04,0.07,0.08,0.14,0.11,0.22c0.05,0.11,0.09,0.22,0.13,0.33
	c0,0.01,0.01,0.01,0.01,0.02c0,0.01,0.01,0.03,0.01,0.04c0.08,0.24,0.14,0.49,0.17,0.73C-24.95-24.48-27.33-19.37-31.86-17.04z"/>
			<path className="st0" d="M-21.28,15.67h-30.38c-3.41,0-6.17,2.76-6.17,6.17V40.5c0,3.41,2.76,6.17,6.17,6.17h3.82v7.87
	c0,0.95,1.12,1.44,1.81,0.8l8.29-8.67h16.46c3.41,0,6.17-2.76,6.17-6.17V21.84C-15.11,18.43-17.87,15.67-21.28,15.67z M-43.57,39.04
	c-0.37,0.19-0.76,0.27-1.14,0.27c-0.9,0-1.77-0.49-2.21-1.34c-0.63-1.22-0.15-2.72,1.07-3.35c1.39-0.72,2.41-1.9,2.96-3.28
	c-1-0.24-1.91-0.84-2.52-1.77c-1.28-1.96-0.73-4.58,1.23-5.85c1.95-1.28,4.57-0.73,5.85,1.23c0.08,0.12,0.13,0.25,0.19,0.38
	c0.04,0.07,0.08,0.14,0.12,0.21c0.05,0.11,0.09,0.22,0.13,0.34c0,0,0,0.01,0.01,0.02c0,0.01,0,0.02,0.01,0.04
	c0.08,0.24,0.14,0.48,0.17,0.73C-36.66,31.6-39.04,36.7-43.57,39.04z M-31.86,39.04c-0.37,0.19-0.76,0.27-1.14,0.27
	c-0.9,0-1.77-0.49-2.21-1.34c-0.63-1.22-0.15-2.72,1.07-3.35c1.39-0.72,2.41-1.9,2.96-3.28c-1-0.24-1.91-0.84-2.52-1.77
	c-1.28-1.96-0.73-4.58,1.23-5.85c1.95-1.28,4.57-0.73,5.85,1.23c0.08,0.12,0.13,0.25,0.19,0.38c0.04,0.07,0.08,0.14,0.12,0.21
	c0.04,0.11,0.09,0.22,0.13,0.34c0,0,0,0.01,0.01,0.02c0,0.01,0,0.02,0.01,0.04c0.08,0.24,0.14,0.48,0.17,0.73
	C-24.95,31.6-27.33,36.7-31.86,39.04z"/>
			<g>
				<g>
					<path className="st0" d="M-213.91-9.98c-0.06-2.41,0.62-4.84,1.75-7.16c0.9-1.85,1.87-3.65,2.71-5.52c3.32-7.4-0.86-16-8.72-17.98
			c-1.53-0.38-3.08-0.52-4.66-0.38c-0.74,0.07-1.26-0.29-1.33-0.91c-0.07-0.64,0.36-1.12,1.13-1.18c8.41-0.67,15.5,5.14,16.59,12.9
			c0.43,3.07,0.03,6.01-1.29,8.81c-0.65,1.38-1.3,2.78-2.05,4.11c-2.18,3.87-2.56,7.95-1.52,12.2c0.44,1.77,0.97,3.51,1.46,5.27
			c0.06,0.23,0.14,0.48,0.12,0.71c-0.04,0.47-0.44,0.84-0.9,0.89c-0.48,0.05-0.93-0.18-1.09-0.65
			C-212.77-1.97-213.95-6.28-213.91-9.98z"/>
				</g>
				<path className="st0" d="M-215.33-20.14c-1.14-1.59-2.27-3.19-3.45-4.75c-0.43-0.56-0.61-1.12-0.6-1.83c0.04-2.95-0.75-5.7-2.24-8.24
		c-3.49-5.95-10.22-9.15-16.71-7.96c-10,1.85-15.43,12.32-11.14,21.54c0.87,1.87,1.84,3.71,2.73,5.57c0.9,1.88,1.38,3.86,1.39,5.95
		c0.01,1.82-0.24,3.61-0.69,5.37c-0.41,1.61-0.91,3.19-1.37,4.79c-0.17,0.59-0.05,1.03,0.36,1.31c0.15,0.1,0.3,0.16,0.45,0.18v0h0
		c0.1,0.02,0.2,0.02,0.3,0l12.54,0.03v-9c-0.86-0.23-1.67-0.58-2.39-1.14c-1.12-0.89-1.67-2.06-1.71-3.48c-0.01-0.33,0-0.65,0-0.98
		c0.01,0,0.02,0,0.02,0c-0.02-0.49,0.11-1.09-0.12-1.43c-0.22-0.32-0.84-0.36-1.28-0.52c-0.4-0.14-0.8-0.27-1.2-0.42
		c-2.06-0.75-2.81-3.09-1.53-4.88c1.2-1.69,2.41-3.37,3.64-5.03c0.34-0.46,0.47-0.91,0.48-1.48c0.05-4.38,1.53-8.22,4.44-11.5
		c0.27-0.31,0.59-0.6,1-0.49c0.32,0.09,0.66,0.34,0.86,0.61c0.25,0.34,0.13,0.75-0.14,1.08c-0.34,0.42-0.71,0.81-1.04,1.23
		c-2.04,2.67-3.07,5.69-3.01,9.05c0.02,1.04-0.24,1.87-0.88,2.69c-1.23,1.58-2.33,3.27-3.55,4.85c-0.58,0.75-0.44,1.68,0.64,1.98
		c0.97,0.26,1.91,0.64,2.86,0.98c0.69,0.24,0.9,0.53,0.9,1.27c0,0.99-0.01,1.99,0,2.98c0.01,1.28,0.42,1.87,1.63,2.31
		c0.43,0.16,0.87,0.26,1.31,0.38c0.22,0.06,0.4,0.16,0.55,0.29c0.28,0.17,0.46,0.48,0.46,0.83v9.79l3.23,0.01l0-0.01
		c0.44,0.03,0.86-0.22,1-0.63c0.07-0.21,0.08-0.45,0.08-0.67c0.01-2.19,0-4.37,0-6.56c0-0.19,0-0.38,0-0.61
		c0.41-0.03,0.76-0.06,1.12-0.09c1.65-0.15,3.27-0.43,4.72-1.27c1.49-0.87,2.27-2.16,2.25-3.9c0-0.57,0.04-1.15-0.01-1.71
		c-0.05-0.51,0.16-0.71,0.61-0.84c0.63-0.17,1.24-0.41,1.85-0.63C-214.66-15.88-213.94-18.2-215.33-20.14z M-243.26-9.9
		C-243.26-9.9-243.26-9.9-243.26-9.9L-243.26-9.9L-243.26-9.9z M-225.1-24.37c-1.08,0.62-2.26,0.9-3.38,0.91
		c-1.36,0-2.53-0.29-3.62-0.91c-0.64-0.37-0.85-0.96-0.54-1.51c0.31-0.55,0.93-0.68,1.57-0.31c1.65,0.96,3.3,0.96,4.95,0
		c0.64-0.37,1.25-0.24,1.56,0.31C-224.25-25.33-224.45-24.74-225.1-24.37z"/>
			</g>
			<g>
				<g>
					<path className="st0" d="M-213.91,45.85c-0.06-2.41,0.62-4.84,1.75-7.16c0.9-1.85,1.87-3.65,2.71-5.52c3.32-7.4-0.86-16-8.72-17.98
			c-1.53-0.38-3.08-0.52-4.66-0.38c-0.74,0.07-1.26-0.29-1.33-0.91c-0.07-0.64,0.36-1.12,1.13-1.18c8.41-0.67,15.5,5.14,16.59,12.9
			c0.43,3.07,0.03,6.01-1.29,8.81c-0.65,1.38-1.3,2.78-2.05,4.11c-2.18,3.87-2.56,7.95-1.52,12.2c0.44,1.77,0.97,3.51,1.46,5.27
			c0.06,0.23,0.14,0.48,0.12,0.71c-0.04,0.47-0.44,0.84-0.9,0.89c-0.48,0.05-0.93-0.18-1.09-0.65
			C-212.77,53.85-213.95,49.55-213.91,45.85z"/>
				</g>
				<path className="st0" d="M-215.33,35.69c-1.14-1.59-2.27-3.19-3.45-4.75c-0.43-0.56-0.61-1.12-0.6-1.83c0.04-2.95-0.75-5.7-2.24-8.24
		c-3.49-5.95-10.22-9.15-16.71-7.96c-10,1.85-15.43,12.32-11.14,21.54c0.87,1.87,1.84,3.71,2.73,5.57c0.9,1.88,1.38,3.86,1.39,5.95
		c0.01,1.82-0.24,3.61-0.69,5.37c-0.41,1.61-0.91,3.19-1.37,4.79c-0.17,0.59-0.05,1.03,0.36,1.31c0.15,0.1,0.3,0.16,0.45,0.18v0h0
		c0.1,0.02,0.2,0.02,0.3,0l12.54,0.03v-9c-0.86-0.23-1.67-0.58-2.39-1.14c-1.12-0.89-1.67-2.06-1.71-3.48c-0.01-0.33,0-0.65,0-0.98
		c0.01,0,0.02,0,0.02,0c-0.02-0.49,0.11-1.09-0.12-1.43c-0.22-0.32-0.84-0.36-1.28-0.52c-0.4-0.14-0.8-0.27-1.2-0.42
		c-2.06-0.75-2.81-3.09-1.53-4.88c1.2-1.69,2.41-3.37,3.64-5.03c0.34-0.46,0.47-0.91,0.48-1.48c0.05-4.38,1.53-8.22,4.44-11.5
		c0.27-0.31,0.59-0.6,1-0.49c0.32,0.09,0.66,0.34,0.86,0.61c0.25,0.34,0.13,0.75-0.14,1.08c-0.34,0.42-0.71,0.81-1.04,1.23
		c-2.04,2.67-3.07,5.69-3.01,9.05c0.02,1.04-0.24,1.87-0.88,2.69c-1.23,1.58-2.33,3.27-3.55,4.85c-0.58,0.75-0.44,1.68,0.64,1.98
		c0.97,0.26,1.91,0.64,2.86,0.98c0.69,0.24,0.9,0.53,0.9,1.27c0,0.99-0.01,1.99,0,2.98c0.01,1.28,0.42,1.87,1.63,2.31
		c0.43,0.16,0.87,0.26,1.31,0.38c0.22,0.06,0.4,0.16,0.55,0.29c0.28,0.17,0.46,0.48,0.46,0.83v9.79l3.23,0.01l0-0.01
		c0.44,0.03,0.86-0.22,1-0.63c0.07-0.21,0.08-0.45,0.08-0.67c0.01-2.19,0-4.37,0-6.56c0-0.19,0-0.38,0-0.61
		c0.41-0.03,0.76-0.06,1.12-0.09c1.65-0.15,3.27-0.43,4.72-1.27c1.49-0.87,2.27-2.16,2.25-3.9c0-0.57,0.04-1.15-0.01-1.71
		c-0.05-0.51,0.16-0.71,0.61-0.84c0.63-0.17,1.24-0.41,1.85-0.63C-214.66,39.95-213.94,37.63-215.33,35.69z M-243.26,45.93
		C-243.26,45.93-243.26,45.93-243.26,45.93L-243.26,45.93L-243.26,45.93z M-225.1,31.46c-1.08,0.62-2.26,0.9-3.38,0.91
		c-1.36,0-2.53-0.29-3.62-0.91c-0.64-0.37-0.85-0.96-0.54-1.51c0.31-0.55,0.93-0.68,1.57-0.31c1.65,0.96,3.3,0.96,4.95,0
		c0.64-0.37,1.25-0.24,1.56,0.31C-224.25,30.5-224.45,31.09-225.1,31.46z"/>
			</g>
			<path className="st0" d="M-201.11-28.65h5.99c1.57,0,2.84,1.27,2.84,2.84v21.97c0,1.34-1.09,2.43-2.43,2.43h-6.4
	c-1.34,0-2.43-1.09-2.43-2.43v-22.39C-203.53-27.56-202.45-28.65-201.11-28.65z"/>
			<path className="st0" d="M-157.47-21.97c-0.31,1.56-1.56,2.69-3.05,2.89c1.31,0.7,2.07,2.18,1.77,3.72c-0.31,1.58-1.63,2.7-3.16,2.8
	c1.39,0.58,2.22,2.08,1.93,3.62c-0.28,1.46-1.49,2.5-2.9,2.63c0.79,0.7,1.9,2.52,0.18,4.54c-3.3,3.39-26.89-1.36-26.89-1.36
	l0.09-23.56c7.42-4.59,7.03-9.01,7.33-12.12c0.2-2.1,2.27-3.55,4.29-2.91c6.57,2.08,4.32,11.25,3.11,14.67l0,0
	c9.33-0.28,12.15,0.35,14.43,0.85l0,0C-158.38-25.82-157.1-23.93-157.47-21.97z"/>
			<path className="st0" d="M-201.11,28.27h5.99c1.57,0,2.84,1.27,2.84,2.84v21.97c0,1.34-1.09,2.43-2.43,2.43h-6.4
	c-1.34,0-2.43-1.09-2.43-2.43V30.7C-203.53,29.36-202.45,28.27-201.11,28.27z"/>
			<path className="st0" d="M-157.47,34.95c-0.31,1.56-1.56,2.69-3.05,2.89c1.31,0.7,2.07,2.18,1.77,3.72c-0.31,1.58-1.63,2.7-3.16,2.8
	c1.39,0.58,2.22,2.08,1.93,3.62c-0.28,1.46-1.49,2.5-2.9,2.63c0.79,0.7,1.9,2.52,0.18,4.54c-3.3,3.39-26.89-1.36-26.89-1.36
	l0.09-23.56c7.42-4.59,7.03-9.01,7.33-12.12c0.2-2.1,2.27-3.55,4.29-2.91c6.57,2.08,4.32,11.25,3.11,14.67l0,0
	c9.33-0.28,12.15,0.35,14.43,0.85l0,0C-158.38,31.1-157.1,32.98-157.47,34.95z"/>
			<rect y="76" className="st2" width="48" height="48" />
			<g>
				<path className="st0" d="M-148.37-220.45v4.78c0,1.3-0.9,2.35-2.02,2.35c-1.15,0-2.02-0.95-2.02-2.2c0-1.14-0.8-2.06-1.78-2.06
		c-0.49,0-0.96,0.25-1.3,0.67c-0.32,0.39-0.49,0.88-0.49,1.39v1.42c-0.04,1.28-0.96,2.31-2.04,2.31c-1.12,0-2.03-1.07-2.04-2.38
		v-0.92c0-1.16-0.81-2.08-1.8-2.08c-1,0-1.81,0.92-1.81,2.08v3.95c0,1.31-0.91,2.38-2.04,2.38c-1.13,0-2.04-1.07-2.04-2.38v-9.3
		c-0.6,0.31-1.01,0.92-1.01,1.64v11.89c0,0.7,0.58,1.27,1.3,1.27h18.78c0.73,0,1.31-0.57,1.31-1.27v-11.89
		C-147.36-219.53-147.77-220.14-148.37-220.45z"/>
				<g>
					<path className="st3" d="M-146.85-219.85v12.45c0,0.73-0.61,1.33-1.37,1.33h-19.68c-0.75,0-1.36-0.6-1.36-1.33v-12.45
			c0-1.07,0.88-1.94,1.96-1.94h18.49C-147.73-221.8-146.85-220.93-146.85-219.85z"/>
				</g>
				<path className="st0" d="M-147.97-202.75h-20.27c-0.9,0-1.64,0.68-1.64,1.51v3.86c0,0.82,0.74,1.5,1.64,1.5h7.47
		c0.06,2.43-0.58,5.61-1.11,8.18c-0.35,1.7-0.62,3.04-0.61,3.76c0.03,2.74,1.56,6.54,4.36,6.54c3.26,0,4.33-4.46,4.34-6.61
		c0-0.98-0.33-2.56-0.72-4.38c-0.53-2.45-1.16-5.48-1.01-7.49h7.55c0.91,0,1.64-0.68,1.64-1.5v-3.86
		C-146.33-202.07-147.06-202.75-147.97-202.75z M-158.04-180.01c-0.86,0-1.55-0.69-1.55-1.55s0.69-1.55,1.55-1.55
		s1.55,0.69,1.55,1.55S-157.18-180.01-158.04-180.01z"/>
			</g>
			<g>
				<g>
					<g>
						<path className="st0" d="M-148.74-167.97h-18.5c-1.91,0-3.46,1.55-3.46,3.44v12.46c0,1.56,1.28,2.83,2.86,2.83h19.69
				c1.58,0,2.87-1.27,2.87-2.83v-12.46C-145.28-166.42-146.83-167.97-148.74-167.97z M-167.24-164.97h18.5
				c0.22,0,0.41,0.16,0.44,0.36v4.26c0,1.3-0.9,2.36-2.02,2.36c-1.15,0-2.02-0.95-2.02-2.2c0-1.14-0.8-2.07-1.78-2.07
				c-0.49,0-0.96,0.25-1.3,0.67c-0.31,0.39-0.49,0.88-0.49,1.4v1.41c-0.04,1.28-0.96,2.31-2.04,2.31c-1.11,0-2.03-1.07-2.04-2.38
				v-0.92c0-1.16-0.8-2.09-1.79-2.09c-1,0-1.81,0.93-1.81,2.09v3.94c0,1.31-0.92,2.38-2.04,2.38c-1.13,0-2.04-1.07-2.04-2.38v-8.83
				C-167.62-164.84-167.44-164.97-167.24-164.97z"/>
					</g>
				</g>
				<g>
					<path className="st0" d="M-147.9-147.42h-20.27c-0.9,0-1.64,0.68-1.64,1.51v3.86c0,0.82,0.74,1.5,1.64,1.5h7.47
			c0.06,2.43-0.58,5.61-1.11,8.18c-0.35,1.7-0.62,3.04-0.61,3.76c0.03,2.74,1.56,6.54,4.36,6.54c3.26,0,4.33-4.46,4.34-6.61
			c0-0.98-0.33-2.56-0.72-4.38c-0.53-2.45-1.16-5.48-1.01-7.49h7.55c0.91,0,1.64-0.68,1.64-1.5v-3.86
			C-146.26-146.74-146.99-147.42-147.9-147.42z M-157.97-124.68c-0.86,0-1.55-0.69-1.55-1.55c0-0.86,0.69-1.55,1.55-1.55
			s1.55,0.69,1.55,1.55C-156.41-125.37-157.11-124.68-157.97-124.68z"/>
				</g>
			</g>
			<g>
				<g>
					<path className="st0" d="M-39.82-202.44v2.7c0,0.45-0.25,0.87-0.64,1.07l-20.54,10.75c-0.22,0.12-0.46,0.18-0.71,0.18
			c-0.24,0-0.47-0.06-0.69-0.17l-21.32-11.21c-0.26-0.13-0.41-0.39-0.41-0.68v-2.95c0-0.27,0.14-0.5,0.36-0.64
			c0.23-0.15,0.51-0.16,0.75-0.03l20.84,10.96c0.31,0.15,0.66,0.15,0.95-0.01l20.32-10.63c0.24-0.13,0.51-0.12,0.74,0.02
			C-39.96-202.94-39.82-202.71-39.82-202.44z"/>
				</g>
				<g>
					<path className="st0" d="M-39.98-193.22v2.7c0,0.45-0.26,0.87-0.65,1.06l-20.53,10.76c-0.22,0.12-0.46,0.18-0.71,0.18
			c-0.24,0-0.47-0.05-0.69-0.17l-21.33-11.22c-0.25-0.13-0.4-0.39-0.4-0.67v-2.95c0-0.27,0.14-0.51,0.37-0.65
			c0.24-0.14,0.51-0.15,0.75-0.02l20.83,10.96c0.31,0.15,0.65,0.15,0.95-0.01l20.32-10.64c0.24-0.13,0.51-0.12,0.74,0.02
			C-40.12-193.73-39.98-193.49-39.98-193.22z"/>
				</g>
				<path className="st0" d="M-83.65-210.3l21.09-11.79c0.39-0.22,0.86-0.21,1.24,0l20.84,11.79c0.87,0.49,0.85,1.76-0.03,2.23
		l-20.84,10.96c-0.37,0.19-0.81,0.19-1.18,0l-21.1-10.96C-84.51-208.53-84.53-209.8-83.65-210.3z"/>
			</g>
			<g>
				<g>
					<path className="st0" d="M-39.82-147.25v2.7c0,0.45-0.25,0.87-0.64,1.07l-20.54,10.75c-0.22,0.12-0.46,0.18-0.71,0.18
			c-0.24,0-0.47-0.06-0.69-0.17l-21.32-11.21c-0.26-0.13-0.41-0.39-0.41-0.68v-2.95c0-0.27,0.14-0.5,0.36-0.64
			c0.23-0.15,0.51-0.16,0.75-0.03l20.84,10.96c0.31,0.15,0.66,0.15,0.95-0.01l20.32-10.63c0.24-0.13,0.51-0.12,0.74,0.02
			C-39.96-147.76-39.82-147.52-39.82-147.25z"/>
				</g>
				<g>
					<path className="st0" d="M-39.98-138.03v2.7c0,0.45-0.26,0.87-0.65,1.06l-20.53,10.76c-0.22,0.12-0.46,0.18-0.71,0.18
			c-0.24,0-0.47-0.05-0.69-0.17l-21.33-11.22c-0.25-0.13-0.4-0.39-0.4-0.67v-2.95c0-0.27,0.14-0.51,0.37-0.65
			c0.24-0.14,0.51-0.15,0.75-0.02l20.83,10.96c0.31,0.15,0.65,0.15,0.95-0.01l20.32-10.64c0.24-0.13,0.51-0.12,0.74,0.02
			C-40.12-138.54-39.98-138.3-39.98-138.03z"/>
				</g>
				<path className="st0" d="M-83.65-155.11l21.09-11.79c0.39-0.22,0.86-0.21,1.24,0l20.84,11.79c0.87,0.49,0.85,1.76-0.03,2.23
		l-20.84,10.96c-0.37,0.19-0.81,0.19-1.18,0l-21.1-10.96C-84.51-153.34-84.53-154.62-83.65-155.11z"/>
			</g>
			<g>
				<path className="st0" d="M43.48,17.65c-1.49,7.83-2.85,16.11-4.33,23.96c-0.2,1.04-1.06,1.8-2.11,1.92
		c-12.36,1.39-12.77-11.78-19.98-13.7c-1.99-0.53-4.12-0.54-6.43,0.31c-2.53,0.93-4.27,3.44-3.9,6.11c0.23,1.62,1.1,2.8,2.6,3.46
		c2.74,1.2,6.53,0.3,7.84-1.24c1.19-1.41,0-2.98-1.21-4.05c-0.45-0.41-1.16-0.83-1.96-0.57c-0.65,0.2-1.07,0.74-1.1,1.14
		c-0.01,0.12-0.04,0.44,0.61,0.74c0.73,0.34,1,1.13,0.61,1.76c-0.4,0.63-1.31,0.87-2.03,0.53c-1.5-0.7-2.3-1.87-2.18-3.22
		c0.12-1.49,1.35-2.85,3.06-3.39c1.77-0.56,3.65-0.13,5.14,1.19c4,3.55,2.36,6.36,1.48,7.41c-1.56,1.82-4.46,2.85-7.35,2.85
		c-1.49,0-2.97-0.27-4.27-0.84c-1.94-0.85-6.16-3.66-3.37-11.27c0.16-0.43,5.75-14.08,8.12-20.69c2.26-6.32,10.08-8.93,15.4-4.84
		c0.98,0.75,7.85,7.63,12.43,7.39C44.99,12.37,44.27,13.5,43.48,17.65z"/>
			</g>
			<g>
				<path className="st0" d="M6.48-206.18c-1.49,7.83-2.85,16.11-4.33,23.96c-0.2,1.04-1.06,1.8-2.11,1.92
		c-12.36,1.39-12.77-11.78-19.98-13.7c-1.99-0.53-4.12-0.54-6.43,0.31c-2.53,0.93-4.27,3.44-3.9,6.11c0.23,1.62,1.1,2.8,2.6,3.46
		c2.74,1.2,6.53,0.3,7.84-1.24c1.19-1.41,0-2.98-1.21-4.05c-0.45-0.41-1.16-0.83-1.96-0.57c-0.65,0.2-1.07,0.74-1.1,1.14
		c-0.01,0.12-0.04,0.44,0.61,0.74c0.73,0.34,1,1.13,0.61,1.76c-0.4,0.63-1.31,0.87-2.03,0.53c-1.5-0.7-2.3-1.87-2.18-3.22
		c0.12-1.49,1.35-2.85,3.06-3.39c1.77-0.56,3.65-0.13,5.14,1.19c4,3.55,2.36,6.36,1.48,7.41c-1.56,1.82-4.46,2.85-7.35,2.85
		c-1.49,0-2.97-0.27-4.27-0.84c-1.94-0.85-6.16-3.66-3.37-11.27c0.16-0.43,5.75-14.08,8.12-20.69c2.26-6.32,10.08-8.93,15.4-4.84
		c0.98,0.75,7.85,7.63,12.43,7.39C7.99-211.46,7.27-210.33,6.48-206.18z"/>
			</g>
			<g>
				<g>
					<g>
						<path className="st0" d="M-103.2-190.81v1.08c0,0.33-0.26,0.59-0.59,0.59h-5.02c-0.33,0-0.59-0.26-0.59-0.59v-1.08
				c0-0.33,0.26-0.59,0.59-0.59h5.02C-103.46-191.4-103.2-191.14-103.2-190.81z"/>
					</g>
					<g>
						<path className="st0" d="M-103.62-180.11c0,1.53-1.22,2.77-2.73,2.77c-1.5,0-2.72-1.24-2.72-2.77l0.49-6.67l0.17-2.36h3.99l0.21,2.36
				L-103.62-180.11z"/>
					</g>
					<g>
						<g>
							<path className="st0" d="M-91.86-202.93v5.36c0,0.76-0.49,1.42-1.21,1.63l-4.76,1.44l-7.5,2.28l0.01,0.81l0.01,1.1
					c0,0.55-0.44,0.99-0.99,0.99c-0.55,0-0.99-0.44-0.99-0.99v-1.92c0-0.87,0.56-1.62,1.39-1.88l8.07-2.45l3.99-1.21v-4.78h-1.79
					c-0.07,0-0.14-0.01-0.2-0.02c-0.45-0.1-0.78-0.49-0.78-0.97c0-0.47,0.34-0.87,0.78-0.97c0.07-0.01,0.13-0.02,0.2-0.02h2.17
					C-92.57-204.52-91.86-203.8-91.86-202.93z"/>
						</g>
					</g>
					<g>
						<path className="st0" d="M-95.83-205.16v3.25c0,1.13-0.88,2.07-2,2.15c-0.05,0.01-0.11,0.01-0.16,0.01h-17.69
				c-1.19,0-2.16-0.97-2.16-2.15v-3.25c0-1.19,0.97-2.16,2.16-2.16h17.69c0.05,0,0.11,0,0.16,0.01
				C-96.71-207.23-95.83-206.29-95.83-205.16z"/>
					</g>
				</g>
				<g>
					<path className="st0" d="M-99.74-223.43h-26.46c-1.05,0-1.91,0.85-1.91,1.91v32.83c0,1.05,0.86,1.91,1.91,1.91h14.9l0.06-0.79
			c-0.53-0.57-0.86-1.35-0.86-2.2v-1.08c0-1.5,1.03-2.78,2.43-3.13c0.5-1.26,1.56-2.27,2.94-2.68l1.6-0.49h-10.62
			c-2.64,0-4.79-2.15-4.79-4.79v-3.26c0-2.64,2.15-4.79,4.79-4.79c0,0,12.15,0,16.44,0.01c0.82,0,1.48-0.66,1.48-1.48v-10.06
			C-97.83-222.58-98.68-223.43-99.74-223.43z M-114.22-191.74c0.63,0,1.15,0.52,1.15,1.15s-0.52,1.14-1.15,1.14
			c-0.63,0-1.14-0.51-1.14-1.14S-114.85-191.74-114.22-191.74z M-125.65-197.3c-0.64,0-1.15-0.51-1.15-1.15
			c0-0.63,0.51-1.14,1.15-1.14c0.63,0,1.14,0.51,1.14,1.14C-124.51-197.81-125.02-197.3-125.65-197.3z M-125.59-212.66
			c-0.63,0-1.15-0.51-1.15-1.14c0-0.64,0.52-1.15,1.15-1.15c0.63,0,1.14,0.51,1.14,1.15C-124.45-213.17-124.96-212.66-125.59-212.66
			z M-121.92-189.45c-0.63,0-1.14-0.51-1.14-1.14s0.51-1.15,1.14-1.15s1.15,0.52,1.15,1.15S-121.29-189.45-121.92-189.45z
			 M-121.92-205.02c-0.63,0-1.14-0.51-1.14-1.14c0-0.63,0.51-1.14,1.14-1.14s1.15,0.51,1.15,1.14
			C-120.77-205.53-121.29-205.02-121.92-205.02z M-121.92-219.96c-0.63,0-1.14-0.51-1.14-1.15c0-0.63,0.51-1.14,1.14-1.14
			s1.15,0.51,1.15,1.14C-120.77-220.47-121.29-219.96-121.92-219.96z M-117.84-212.66c-0.63,0-1.14-0.51-1.14-1.14
			c0-0.64,0.51-1.15,1.14-1.15c0.64,0,1.15,0.51,1.15,1.15C-116.69-213.17-117.2-212.66-117.84-212.66z M-114.17-219.96
			c-0.64,0-1.15-0.51-1.15-1.15c0-0.63,0.51-1.14,1.15-1.14c0.63,0,1.14,0.51,1.14,1.14C-113.03-220.47-113.54-219.96-114.17-219.96
			z M-110.15-212.66c-0.63,0-1.14-0.51-1.14-1.14c0-0.64,0.51-1.15,1.14-1.15c0.63,0,1.15,0.51,1.15,1.15
			C-109-213.17-109.52-212.66-110.15-212.66z M-106.47-219.96c-0.64,0-1.15-0.51-1.15-1.15c0-0.63,0.51-1.14,1.15-1.14
			c0.63,0,1.14,0.51,1.14,1.14C-105.33-220.47-105.84-219.96-106.47-219.96z M-102.84-212.66c-0.63,0-1.15-0.51-1.15-1.14
			c0-0.64,0.52-1.15,1.15-1.15c0.63,0,1.14,0.51,1.14,1.15C-101.7-213.17-102.21-212.66-102.84-212.66z M-99.17-219.96
			c-0.63,0-1.14-0.51-1.14-1.15c0-0.63,0.51-1.14,1.14-1.14s1.15,0.51,1.15,1.14C-98.02-220.47-98.54-219.96-99.17-219.96z"/>
				</g>
			</g>
			<g>
				<g>
					<g>
						<path className="st0" d="M-103.2-135.62v1.08c0,0.33-0.26,0.59-0.59,0.59h-5.02c-0.33,0-0.59-0.26-0.59-0.59v-1.08
				c0-0.33,0.26-0.59,0.59-0.59h5.02C-103.46-136.22-103.2-135.95-103.2-135.62z"/>
					</g>
					<g>
						<path className="st0" d="M-103.62-124.92c0,1.53-1.22,2.77-2.73,2.77c-1.5,0-2.72-1.24-2.72-2.77l0.49-6.67l0.17-2.36h3.99l0.21,2.36
				L-103.62-124.92z"/>
					</g>
					<g>
						<g>
							<path className="st0" d="M-91.86-147.74v5.36c0,0.76-0.49,1.42-1.21,1.63l-4.76,1.44l-7.5,2.28l0.01,0.81l0.01,1.1
					c0,0.55-0.44,0.99-0.99,0.99c-0.55,0-0.99-0.44-0.99-0.99v-1.92c0-0.87,0.56-1.62,1.39-1.88l8.07-2.45l3.99-1.21v-4.78h-1.79
					c-0.07,0-0.14-0.01-0.2-0.02c-0.45-0.1-0.78-0.49-0.78-0.97c0-0.47,0.34-0.87,0.78-0.97c0.07-0.01,0.13-0.02,0.2-0.02h2.17
					C-92.57-149.34-91.86-148.62-91.86-147.74z"/>
						</g>
					</g>
					<g>
						<path className="st0" d="M-95.83-149.97v3.25c0,1.13-0.88,2.07-2,2.15c-0.05,0.01-0.11,0.01-0.16,0.01h-17.69
				c-1.19,0-2.16-0.97-2.16-2.15v-3.25c0-1.19,0.97-2.16,2.16-2.16h17.69c0.05,0,0.11,0,0.16,0.01
				C-96.71-152.04-95.83-151.11-95.83-149.97z"/>
					</g>
				</g>
				<g>
					<path className="st0" d="M-99.74-168.24h-26.46c-1.05,0-1.91,0.85-1.91,1.91v32.83c0,1.05,0.86,1.91,1.91,1.91h14.9l0.06-0.79
			c-0.53-0.57-0.86-1.35-0.86-2.2v-1.08c0-1.5,1.03-2.78,2.43-3.13c0.5-1.26,1.56-2.27,2.94-2.68l1.6-0.49h-10.62
			c-2.64,0-4.79-2.15-4.79-4.79v-3.26c0-2.64,2.15-4.79,4.79-4.79c0,0,12.15,0,16.44,0.01c0.82,0,1.48-0.66,1.48-1.48v-10.06
			C-97.83-167.39-98.68-168.24-99.74-168.24z M-114.22-136.55c0.63,0,1.15,0.52,1.15,1.15s-0.52,1.14-1.15,1.14
			c-0.63,0-1.14-0.51-1.14-1.14S-114.85-136.55-114.22-136.55z M-125.65-142.11c-0.64,0-1.15-0.51-1.15-1.15
			c0-0.63,0.51-1.14,1.15-1.14c0.63,0,1.14,0.51,1.14,1.14C-124.51-142.62-125.02-142.11-125.65-142.11z M-125.59-157.47
			c-0.63,0-1.15-0.51-1.15-1.14c0-0.64,0.52-1.15,1.15-1.15c0.63,0,1.14,0.51,1.14,1.15C-124.45-157.98-124.96-157.47-125.59-157.47
			z M-121.92-134.26c-0.63,0-1.14-0.51-1.14-1.14s0.51-1.15,1.14-1.15s1.15,0.52,1.15,1.15S-121.29-134.26-121.92-134.26z
			 M-121.92-149.83c-0.63,0-1.14-0.51-1.14-1.14c0-0.63,0.51-1.14,1.14-1.14s1.15,0.51,1.15,1.14
			C-120.77-150.34-121.29-149.83-121.92-149.83z M-121.92-164.77c-0.63,0-1.14-0.51-1.14-1.15c0-0.63,0.51-1.14,1.14-1.14
			s1.15,0.51,1.15,1.14C-120.77-165.28-121.29-164.77-121.92-164.77z M-117.84-157.47c-0.63,0-1.14-0.51-1.14-1.14
			c0-0.64,0.51-1.15,1.14-1.15c0.64,0,1.15,0.51,1.15,1.15C-116.69-157.98-117.2-157.47-117.84-157.47z M-114.17-164.77
			c-0.64,0-1.15-0.51-1.15-1.15c0-0.63,0.51-1.14,1.15-1.14c0.63,0,1.14,0.51,1.14,1.14C-113.03-165.28-113.54-164.77-114.17-164.77
			z M-110.15-157.47c-0.63,0-1.14-0.51-1.14-1.14c0-0.64,0.51-1.15,1.14-1.15c0.63,0,1.15,0.51,1.15,1.15
			C-109-157.98-109.52-157.47-110.15-157.47z M-106.47-164.77c-0.64,0-1.15-0.51-1.15-1.15c0-0.63,0.51-1.14,1.15-1.14
			c0.63,0,1.14,0.51,1.14,1.14C-105.33-165.28-105.84-164.77-106.47-164.77z M-102.84-157.47c-0.63,0-1.15-0.51-1.15-1.14
			c0-0.64,0.52-1.15,1.15-1.15c0.63,0,1.14,0.51,1.14,1.15C-101.7-157.98-102.21-157.47-102.84-157.47z M-99.17-164.77
			c-0.63,0-1.14-0.51-1.14-1.15c0-0.63,0.51-1.14,1.14-1.14s1.15,0.51,1.15,1.14C-98.02-165.28-98.54-164.77-99.17-164.77z"/>
				</g>
			</g>
		</svg>
	);
};

export const BasicFlooring = props => {
	return (
		<svg id='BasicFlooring' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 48 48'}>
			<defs>
				<style>{`
					svg#BasicFlooring .st0{fill:${props.color};}
				`}</style>
			</defs>

			<g>
				<g>
					<path className="st0" d="M46.38,21.95v2.7c0,0.45-0.25,0.87-0.64,1.07L25.2,36.47c-0.22,0.12-0.46,0.18-0.71,0.18
						c-0.24,0-0.47-0.06-0.69-0.17L2.48,25.27c-0.26-0.13-0.41-0.39-0.41-0.68v-2.95c0-0.27,0.14-0.5,0.36-0.64
						c0.23-0.15,0.51-0.16,0.75-0.03l20.84,10.96c0.31,0.15,0.66,0.15,0.95-0.01l20.32-10.63c0.24-0.13,0.51-0.12,0.74,0.02
						C46.24,21.45,46.38,21.68,46.38,21.95z"/>
				</g>
				<g>
					<path className="st0" d="M46.22,31.17v2.7c0,0.45-0.26,0.87-0.65,1.06L25.04,45.69c-0.22,0.12-0.46,0.18-0.71,0.18
						c-0.24,0-0.47-0.05-0.69-0.17L2.31,34.48c-0.25-0.13-0.4-0.39-0.4-0.67v-2.95c0-0.27,0.14-0.51,0.37-0.65
						c0.24-0.14,0.51-0.15,0.75-0.02l20.83,10.96c0.31,0.15,0.65,0.15,0.95-0.01L45.13,30.5c0.24-0.13,0.51-0.12,0.74,0.02
						C46.08,30.66,46.22,30.9,46.22,31.17z"/>
				</g>
				<path className="st0" d="M2.55,14.09L23.64,2.3c0.39-0.22,0.86-0.21,1.24,0l20.84,11.79c0.87,0.49,0.85,1.76-0.03,2.23L24.85,27.28
					c-0.37,0.19-0.81,0.19-1.18,0L2.57,16.32C1.69,15.86,1.67,14.59,2.55,14.09z"/>
			</g>
		</svg>
	);
};

export const BasicFraming = props => {
	return (
		<svg id='BasicFraming' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 48 48'}>
			<defs>
				<style>{`
					svg#BasicFraming .cls-1{fill:${props.color};}
				`}</style>
			</defs>

			<path className="cls-1" d="M23.87,4.51a1.53,1.53,0,0,0-.94.46l-21,22A1.5,1.5,0,0,0,3,29.5H8V43a1.5,1.5,0,0,0,1.5,1.5H20a1.5,1.5,0,0,0,1.5-1.5V29.5h5V43a1.5,1.5,0,0,0,1.5,1.5H38.5A1.5,1.5,0,0,0,40,43V29.5h5A1.5,1.5,0,0,0,46.5,28a1.53,1.53,0,0,0-.41-1l-6.25-6.73,0-5.54a1.5,1.5,0,0,0-1.5-1.49H33L25.09,5A1.52,1.52,0,0,0,23.87,4.51ZM24,8.17l7.29,7.57a1.48,1.48,0,0,0,1.08.47h4.43l0,4.62a1.55,1.55,0,0,0,.41,1l4.31,4.65H38.5A1.5,1.5,0,0,0,37,28V41.49H29.5V28A1.5,1.5,0,0,0,28,26.5H20a1.5,1.5,0,0,0-1.5,1.5V41.49H11V28a1.5,1.5,0,0,0-1.49-1.5h-3Z" />
		</svg>
	);
};

export const BasicPainting = props => {
	return (
		<svg id='BasicPainting' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 48 48'}>
			<defs>
				<style>{`
					svg#BasicPainting .st0{fill:${props.color};}
				`}</style>
			</defs>

			<g>
				<g>
					<g>
						<path className="st0" d="M34.14,1.05h-18.5c-1.91,0-3.46,1.55-3.46,3.44v12.46c0,1.56,1.28,2.83,2.86,2.83h19.69
				c1.58,0,2.87-1.27,2.87-2.83V4.49C37.6,2.6,36.05,1.05,34.14,1.05z M15.64,4.05h18.5c0.22,0,0.41,0.16,0.44,0.36v4.26
				c0,1.3-0.9,2.36-2.02,2.36c-1.15,0-2.02-0.95-2.02-2.2c0-1.14-0.8-2.07-1.78-2.07c-0.49,0-0.96,0.25-1.3,0.67
				c-0.31,0.39-0.49,0.88-0.49,1.4v1.41c-0.04,1.28-0.96,2.31-2.04,2.31c-1.11,0-2.03-1.07-2.04-2.38V9.25
				c0-1.16-0.8-2.09-1.79-2.09c-1,0-1.81,0.93-1.81,2.09v3.94c0,1.31-0.92,2.38-2.04,2.38c-1.13,0-2.04-1.07-2.04-2.38V4.36
				C15.26,4.18,15.44,4.05,15.64,4.05z"/>
					</g>
				</g>
				<g>
					<path className="st0" d="M34.98,21.6H14.71c-0.9,0-1.64,0.68-1.64,1.51v3.86c0,0.82,0.74,1.5,1.64,1.5h7.47
			c0.06,2.43-0.58,5.61-1.11,8.18c-0.35,1.7-0.62,3.04-0.61,3.76c0.03,2.74,1.56,6.54,4.36,6.54c3.26,0,4.33-4.46,4.34-6.61
			c0-0.98-0.33-2.56-0.72-4.38c-0.53-2.45-1.16-5.48-1.01-7.49h7.55c0.91,0,1.64-0.68,1.64-1.5v-3.86
			C36.62,22.28,35.89,21.6,34.98,21.6z M24.91,44.34c-0.86,0-1.55-0.69-1.55-1.55s0.69-1.55,1.55-1.55s1.55,0.69,1.55,1.55
			C26.47,43.65,25.77,44.34,24.91,44.34z"/>
				</g>
			</g>
		</svg>
	);
};

export const BasicPlumbing = props => {
	return (
		<svg id='BasicPlumbing' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 48 48'}>
			<defs>
				<style>{`
					svg#BasicPlumbing .cls-1{fill:${props.color};}
				`}</style>
			</defs>

			<path className="cls-1" d="M21.66,12.52v0a1.14,1.14,0,0,1,1.14-1.14H24V8.75a.27.27,0,0,0-.16-.28,3.52,3.52,0,0,1-1.39-1.26A.36.36,0,0,0,22.18,7H16.71a1.84,1.84,0,1,1,0-3.68h5.39a.59.59,0,0,0,.48-.27,3.65,3.65,0,0,1,6.08.06.41.41,0,0,0,.4.2h5.26a2,2,0,0,1,2,1.57A1.82,1.82,0,0,1,34.43,7H29a.38.38,0,0,0-.36.18,3.68,3.68,0,0,1-1.42,1.29.22.22,0,0,0-.11.18c0,.85,0,1.71,0,2.56a.2.2,0,0,0,0,.09h1.21a1.14,1.14,0,0,1,1.14,1.14h0a1.14,1.14,0,0,0,1.14,1.14h4.17a1.14,1.14,0,0,1,1.14,1.14v8.85a1.13,1.13,0,0,1-1.13,1.14H24.16a3.14,3.14,0,0,0-2.91,1.6,3.1,3.1,0,0,0-.28.86,1.15,1.15,0,0,1-1.12.92h-9A1.14,1.14,0,0,1,9.72,27c0-.82,0-1.91,0-2.57A10.82,10.82,0,0,1,18,13.91a16.31,16.31,0,0,1,2.53-.26A1.13,1.13,0,0,0,21.66,12.52Z" />
			<rect className="cls-1" x="7.82" y="29.84" width="14.92" height="4.26" rx="2.13" />
			<path className="cls-1" d="M15.19,36.78l.08.09a34.43,34.43,0,0,1,2.56,4.7A6.71,6.71,0,0,1,18.29,43a3.06,3.06,0,0,1-2.07,3.32,3.13,3.13,0,0,1-4.15-2.88,3.78,3.78,0,0,1,.22-1.14,15.73,15.73,0,0,1,1.37-2.94c.45-.81.93-1.6,1.4-2.4Z" />
			<rect className="cls-1" x="37.7" y="11.72" width="4.28" height="14.94" rx="1.02" />
		</svg>
	);
};

export const BasicRoofing = props => {
	return (
		<svg id='BasicRoofing' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 48 48'}>
			<defs>
				<style>{`
					svg#BasicRoofing .cls-1,.cls-2,.cls-3{fill:none;stroke:${props.color};stroke-linecap:round;stroke-linejoin:round;}
					svg#BasicRoofing .cls-2{stroke-dasharray:1.92 3.83;}
					svg#BasicRoofing .cls-3{stroke-dasharray:1.96 3.93;}
					svg#BasicRoofing .cls-4{fill:${props.color};}
				`}</style>
			</defs>

			<polyline className="cls-1" points="9.45 27.79 9.45 26.79 10.45 26.79" />
			<line className="cls-2" x1="14.28" y1="26.79" x2="35.35" y2="26.79" />
			<polyline className="cls-1" points="37.26 26.79 38.26 26.79 38.26 27.79" />
			<line className="cls-3" x1="38.26" y1="31.71" x2="38.26" y2="41.53" />
			<polyline className="cls-1" points="38.26 43.49 38.26 44.49 37.26 44.49" />
			<line className="cls-2" x1="33.43" y1="44.49" x2="12.36" y2="44.49" />
			<polyline className="cls-1" points="10.45 44.49 9.45 44.49 9.45 43.49" />
			<line className="cls-3" x1="9.45" y1="39.57" x2="9.45" y2="29.75" />
			<path className="cls-4" d="M46,27l-6.24-6.73,0-5.54a1.5,1.5,0,0,0-1.5-1.49h-5.3L25,5a1.51,1.51,0,0,0-1.22-.46,1.56,1.56,0,0,0-.94.46l-21,22A1.5,1.5,0,0,0,2.88,29.5h42A1.5,1.5,0,0,0,46.36,28,1.44,1.44,0,0,0,46,27Z" />
		</svg>
	);
};

export const BasicSiding = props => {
	return (
		<svg id='BasicSiding' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 48 48'}>
			<defs>
				<style>{`
					svg#BasicSiding .cls-1{fill:${props.color};}
				`}</style>
			</defs>

			<path className="cls-1" d="M46.09,26.36l-6.25-6.73,0-5.54a1.5,1.5,0,0,0-1.5-1.49H33L25.09,4.36a1.48,1.48,0,0,0-2.16,0l-21,22A1.5,1.5,0,0,0,3,28.89H8V42.38a1.5,1.5,0,0,0,1.5,1.5H20a1.5,1.5,0,0,0,1.5-1.5V28.89h5V42.38a1.5,1.5,0,0,0,1.5,1.5H38.5a1.5,1.5,0,0,0,1.5-1.5V28.89h5a1.5,1.5,0,0,0,1.5-1.5A1.52,1.52,0,0,0,46.09,26.36ZM19.35,11.54h9.3a1,1,0,0,1,0,2h-9.3a1,1,0,0,1,0-2Zm-4,4.25H32.62a1,1,0,0,1,0,2H15.38a1,1,0,0,1,0-2Zm-4,4.26H36.59a1,1,0,0,1,0,2H11.41a1,1,0,0,1,0-2Zm7.07,21.6H10.92a1,1,0,0,1,0-2h7.56a1,1,0,0,1,0,2Zm0-4.25H10.92a1,1,0,0,1,0-2h7.56a1,1,0,0,1,0,2Zm0-4.26H10.92a1,1,0,0,1,0-2h7.56a1,1,0,1,1,0,2ZM37,41.65H29.46a1,1,0,0,1,0-2H37a1,1,0,0,1,0,2Zm0-4.25H29.46a1,1,0,0,1,0-2H37a1,1,0,0,1,0,2Zm0-4.26H29.46a1,1,0,0,1,0-2H37a1,1,0,0,1,0,2Zm3.54-6.84H7.44a1,1,0,0,1,0-2H40.56a1,1,0,0,1,0,2Z" />
		</svg>
	);
};

export const BasicWallpsper = props => {
	return (
		<svg id='BasicWallpsper' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 48 48'}>
			<defs>
				<style>{`
					svg#BasicWallpsper .st0{fill:${props.color};}
				`}</style>
			</defs>

			<g>
				<g>
					<g>
						<path className="st0" d="M31.37,33.57v1.08c0,0.33-0.26,0.59-0.59,0.59h-5.02c-0.33,0-0.59-0.26-0.59-0.59v-1.08
				c0-0.33,0.26-0.59,0.59-0.59h5.02C31.11,32.99,31.37,33.24,31.37,33.57z"/>
					</g>
					<g>
						<path className="st0" d="M30.95,44.27c0,1.53-1.22,2.77-2.73,2.77c-1.5,0-2.72-1.24-2.72-2.77l0.49-6.67l0.17-2.36h3.99l0.21,2.36
				L30.95,44.27z"/>
					</g>
					<g>
						<g>
							<path className="st0" d="M42.71,21.46v5.36c0,0.76-0.49,1.42-1.21,1.63l-4.76,1.44l-7.5,2.28l0.01,0.81l0.01,1.1
					c0,0.55-0.44,0.99-0.99,0.99c-0.55,0-0.99-0.44-0.99-0.99v-1.92c0-0.87,0.56-1.62,1.39-1.88l8.07-2.45l3.99-1.21v-4.78h-1.79
					c-0.07,0-0.14-0.01-0.2-0.02c-0.45-0.1-0.78-0.49-0.78-0.97c0-0.47,0.34-0.87,0.78-0.97c0.07-0.01,0.13-0.02,0.2-0.02h2.17
					C42,19.86,42.71,20.58,42.71,21.46z"/>
						</g>
					</g>
					<g>
						<path className="st0" d="M38.74,19.22v3.25c0,1.13-0.88,2.07-2,2.15c-0.05,0.01-0.11,0.01-0.16,0.01H18.89
				c-1.19,0-2.16-0.97-2.16-2.15v-3.25c0-1.19,0.97-2.16,2.16-2.16h17.69c0.05,0,0.11,0,0.16,0.01
				C37.86,17.15,38.74,18.1,38.74,19.22z"/>
					</g>
				</g>
				<g>
					<path className="st0" d="M34.83,0.96H8.37c-1.05,0-1.91,0.85-1.91,1.91V35.7c0,1.05,0.86,1.91,1.91,1.91h14.9l0.06-0.79
			c-0.53-0.57-0.86-1.35-0.86-2.2v-1.08c0-1.5,1.03-2.78,2.43-3.13c0.5-1.26,1.56-2.27,2.94-2.68l1.6-0.49H18.82
			c-2.64,0-4.79-2.15-4.79-4.79v-3.26c0-2.64,2.15-4.79,4.79-4.79c0,0,12.15,0,16.44,0.01c0.82,0,1.48-0.66,1.48-1.48V2.87
			C36.74,1.8,35.89,0.96,34.83,0.96z M20.35,32.64c0.63,0,1.15,0.52,1.15,1.15s-0.52,1.14-1.15,1.14c-0.63,0-1.14-0.51-1.14-1.14
			S19.72,32.64,20.35,32.64z M8.92,27.08c-0.64,0-1.15-0.51-1.15-1.15c0-0.63,0.51-1.14,1.15-1.14c0.63,0,1.14,0.51,1.14,1.14
			C10.06,26.57,9.55,27.08,8.92,27.08z M8.98,11.72c-0.63,0-1.15-0.51-1.15-1.14c0-0.64,0.52-1.15,1.15-1.15
			c0.63,0,1.14,0.51,1.14,1.15C10.12,11.21,9.61,11.72,8.98,11.72z M12.65,34.93c-0.63,0-1.14-0.51-1.14-1.14s0.51-1.15,1.14-1.15
			s1.15,0.52,1.15,1.15S13.28,34.93,12.65,34.93z M12.65,19.36c-0.63,0-1.14-0.51-1.14-1.14s0.51-1.14,1.14-1.14
			s1.15,0.51,1.15,1.14S13.28,19.36,12.65,19.36z M12.65,4.42c-0.63,0-1.14-0.51-1.14-1.15c0-0.63,0.51-1.14,1.14-1.14
			s1.15,0.51,1.15,1.14C13.8,3.91,13.28,4.42,12.65,4.42z M16.73,11.72c-0.63,0-1.14-0.51-1.14-1.14c0-0.64,0.51-1.15,1.14-1.15
			c0.64,0,1.15,0.51,1.15,1.15C17.88,11.21,17.37,11.72,16.73,11.72z M20.4,4.42c-0.64,0-1.15-0.51-1.15-1.15
			c0-0.63,0.51-1.14,1.15-1.14c0.63,0,1.14,0.51,1.14,1.14C21.54,3.91,21.03,4.42,20.4,4.42z M24.42,11.72
			c-0.63,0-1.14-0.51-1.14-1.14c0-0.64,0.51-1.15,1.14-1.15s1.15,0.51,1.15,1.15C25.57,11.21,25.05,11.72,24.42,11.72z M28.1,4.42
			c-0.64,0-1.15-0.51-1.15-1.15c0-0.63,0.51-1.14,1.15-1.14c0.63,0,1.14,0.51,1.14,1.14C29.24,3.91,28.73,4.42,28.1,4.42z
			M31.73,11.72c-0.63,0-1.15-0.51-1.15-1.14c0-0.64,0.52-1.15,1.15-1.15c0.63,0,1.14,0.51,1.14,1.15
			C32.87,11.21,32.36,11.72,31.73,11.72z M35.4,4.42c-0.63,0-1.14-0.51-1.14-1.15c0-0.63,0.51-1.14,1.14-1.14s1.15,0.51,1.15,1.14
			C36.55,3.91,36.03,4.42,35.4,4.42z"/>
				</g>
			</g>
		</svg>
	);
};

export const ConflictResolution = props => {
	return (
		<svg id='ConflictResolution' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 48 48'}>
			<defs>
				<style>{`
					svg#ConflictResolution .cls-1{fill:${props.color};}
				`}</style>
			</defs>

			<path className="cls-1" d="M40.4,31.78a4.09,4.09,0,0,0-1.5-5.59h0a4.09,4.09,0,0,0-4.35.18L38.8,6.8a4.26,4.26,0,0,0-2.86-5,4.1,4.1,0,0,0-5.09,3.08l-3.17,14.6L24.54,5A4.2,4.2,0,0,0,20,1.64a4.08,4.08,0,0,0-3.52,4.93l2.76,12.72a3.33,3.33,0,0,0-2.63-1,3.5,3.5,0,0,0-3.11,3.55v.74A3.38,3.38,0,0,0,10,19.25a3.51,3.51,0,0,0-3.19,3.57V35.34a6,6,0,0,0,.3,1.39l3.69,7.69a3.46,3.46,0,0,0,3.11,2H31c1.9,0,2.5-1.73,3.45-3.45" />
		</svg>
	);
};

export const ConstructiveFeedback = props => {
	return (
		<svg id='ConstructiveFeedback' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 47.8 45.85'}>
			<defs>
				<style>{`
					svg#ConstructiveFeedback .cls-1{fill:${props.color};}
				`}</style>
			</defs>

			<g>
				<g>
					<path className="cls-1" d="M21.68,29.69a2.22,2.22,0,0,0,4.43,0V25.14h4.44a2.22,2.22,0,0,0,0-4.44H26.11V16.15a2.22,2.22,0,0,0-4.43,0V20.7H17.24a2.22,2.22,0,0,0,0,4.44h4.44Z" />
					<path className="cls-1" d="M12.66,27.23h-.07a2.22,2.22,0,0,0-2.14,2.29l.19,5.95A18.78,18.78,0,0,1,8,13.73,17.9,17.9,0,0,1,18.93,5.09a17.71,17.71,0,0,1,8.28-.3A2.22,2.22,0,0,0,28.08.44,22,22,0,0,0,17.75.82,22.26,22.26,0,0,0,4.14,11.57,23,23,0,0,0,2.1,29a23.34,23.34,0,0,0,5.18,9.38l-5.12.12a2.22,2.22,0,0,0,.06,4.44h0l10.81-.27a2.17,2.17,0,0,0,1.55-.69,2.22,2.22,0,0,0,.61-1.6l-.36-11A2.22,2.22,0,0,0,12.66,27.23Z" />
					<path className="cls-1" d="M47.8,5.11a2.22,2.22,0,0,0-2.22-2.17h-.06l-10.8.27a2.26,2.26,0,0,0-1.56.7,2.23,2.23,0,0,0-.6,1.59l.36,11a2.22,2.22,0,0,0,2.21,2.15h.08a2.22,2.22,0,0,0,2.14-2.29l-.19-5.86a18.75,18.75,0,0,1,2.57,21.67,17.95,17.95,0,0,1-18.66,9,2.22,2.22,0,1,0-.74,4.37A22.34,22.34,0,0,0,43.61,34.28a23,23,0,0,0,2-17.38,23.24,23.24,0,0,0-5.18-9.39l5.16-.13A2.22,2.22,0,0,0,47.8,5.11Z" />
				</g>
			</g>
		</svg>
	);
};

export const DifficultConversation = props => {
	return (
		<svg id='DifficultConversation' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 39.68 45.92'}>
			<defs>
				<style>{`
					svg#DifficultConversation .cls-1{fill:${props.color};}
				`}</style>
			</defs>

			<g>
				<g>
					<path className="cls-1" d="M33.36,34.75a7.38,7.38,0,1,0-10.82,0,10.43,10.43,0,0,0-6.45,9.63,1.59,1.59,0,0,0,1.59,1.59H38.09a1.59,1.59,0,0,0,1.59-1.59A10.45,10.45,0,0,0,33.36,34.75Z" />
					<path className="cls-1" d="M19,33.67a8.46,8.46,0,0,0-4.69-7.55,6.09,6.09,0,1,0-9.55-.05A8.44,8.44,0,0,0,0,33.67a1.59,1.59,0,0,0,1.59,1.59H17.43A1.6,1.6,0,0,0,19,33.67Z" />
					<path className="cls-1" d="M28,19.82a1.54,1.54,0,0,1-1.07-.44l-2.68-2.69a.7.7,0,0,0-.49-.2H20.29a3.72,3.72,0,0,1-3.71-3.71V3.71A3.71,3.71,0,0,1,20.29,0H35.66a3.72,3.72,0,0,1,3.71,3.71v9.07a3.72,3.72,0,0,1-3.71,3.71H32.22a.7.7,0,0,0-.49.2l-2.68,2.69A1.55,1.55,0,0,1,28,19.82ZM20.29,3a.67.67,0,0,0-.68.68v9.07a.68.68,0,0,0,.68.68h3.44a3.75,3.75,0,0,1,2.63,1.09L28,16.16l1.62-1.61a3.69,3.69,0,0,1,2.63-1.09h3.44a.68.68,0,0,0,.68-.68V3.71A.67.67,0,0,0,35.66,3Z" />
					<path className="cls-1" d="M32.43,10.36a1.77,1.77,0,1,1,1.76-1.77A1.76,1.76,0,0,1,32.43,10.36Z" />
					<path className="cls-1" d="M23.91,10.36a1.77,1.77,0,1,1,1.75-1.77A1.76,1.76,0,0,1,23.91,10.36Z" />
					<path className="cls-1" d="M28.17,10.36a1.77,1.77,0,1,1,1.75-1.77A1.76,1.76,0,0,1,28.17,10.36Z" />
				</g>
			</g>
		</svg>
	);
};

export const Drywall = props => {
	return (
		<svg id='Drywall' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 35.14 45.85'}>
			<defs>
				<style>{`
					svg#Drywall .cls-1{fill:${props.color};}
				`}</style>
			</defs>

			<g>
				<g>
					<rect className="cls-1" x="0.63" y="0.66" width="3.25" height="40.93" rx="1.48" />
					<rect className="cls-1" x="15.85" y="-15.85" width="3.43" height="35.14" rx="1.51" transform="translate(19.29 -15.85) rotate(90)" />
					<rect className="cls-1" x="10.51" y="0.03" width="3.37" height="45.82" />
					<rect className="cls-1" x="21.26" y="0.03" width="3.37" height="45.82" />
					<path className="cls-1" d="M0,44.15V35a.66.66,0,0,1,.65-.65c18.65-.67,20.8-30.56,32.26-34A1.71,1.71,0,0,1,35.14,2V44.16a1.69,1.69,0,0,1-1.7,1.69H1.7A1.7,1.7,0,0,1,0,44.15Z" />
				</g>
			</g>
		</svg>
	);
};

export const Electricity = props => {
	return (
		<svg id='Electricity' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 31.13 46.05'}>
			<defs>
				<style>{`
					svg#Electricity .cls-1{fill:${props.color};}
				`}</style>
			</defs>

			<g>
				<g>
					<path className="cls-1" d="M17.76,6.11,9.62,16.58a.27.27,0,0,0,.21.43h4.82a.27.27,0,0,1,.26.35L12,26.45a.27.27,0,0,0,.47.24L21.8,14.24a.26.26,0,0,0-.21-.42H16.7a.27.27,0,0,1-.26-.33l1.79-7.15A.27.27,0,0,0,17.76,6.11Z" />
					<path className="cls-1" d="M20.7,35H10.42a1.16,1.16,0,1,0,0,2.31H20.7a1.17,1.17,0,1,0,0-2.31Z" />
					<path className="cls-1" d="M20.7,39.33H10.42a1.16,1.16,0,1,0,0,2.31H20.7a1.17,1.17,0,1,0,0-2.31Z" />
					<path className="cls-1" d="M12.25,43.66a.55.55,0,0,0-.43.9,4.73,4.73,0,0,0,3.74,1.49,4.74,4.74,0,0,0,3.75-1.49.55.55,0,0,0-.43-.9H12.25Z" />
					<path className="cls-1" d="M29.53,7.56a13.49,13.49,0,0,0-5.21-5.41A17.26,17.26,0,0,0,15.56,0,17.26,17.26,0,0,0,6.8,2.15,13.4,13.4,0,0,0,1.6,7.56,15.17,15.17,0,0,0,4.45,25C8,28.59,8.21,31.47,8.22,31.61a1.31,1.31,0,0,0,1.4,1.2H21.5a1.32,1.32,0,0,0,1.41-1.2c0-.14.26-3,3.77-6.58A15.21,15.21,0,0,0,29.53,7.56ZM12.26,30.34H10.83a15.65,15.65,0,0,0-4.25-6.93A13,13,0,0,1,4.16,8.59c2.06-3.95,6.11-6.12,11.4-6.12S24.91,4.64,27,8.59a13.07,13.07,0,0,1-2.42,14.82,15.45,15.45,0,0,0-4.25,6.93H18.86m-2.26,0H14.53" />
				</g>
			</g>
		</svg>
	);
};

export const EmpatheticParaphrase = props => {
	return (
		<svg id='EmpatheticParaphrase' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 48 48'}>
			<defs>
				<style>{`
					svg#EmpatheticParaphrase .cls-1{fill:${props.color};}
				`}</style>
			</defs>

			<path className="cls-1" d="M31.83,29.53l-3.39-4.77a2,2,0,0,1-.35-1.07A14.16,14.16,0,0,0,14.17,10,12.87,12.87,0,0,0,1.45,22.72c0,3.65,1.39,6.53,2.63,9.06,1,2,1.8,3.71,1.8,5.42a31.42,31.42,0,0,1-1.54,8.55.75.75,0,0,0,.1.71.8.8,0,0,0,.64.34h0l15.75,0a.79.79,0,0,0,.79-.79v-5.5h3a3.5,3.5,0,0,0,3.5-3.5V34.21a.36.36,0,0,1,.33-.37l1.46-.13a2.66,2.66,0,0,0,2.18-1.53A2.63,2.63,0,0,0,31.83,29.53ZM18.34,40.46h-3a3.5,3.5,0,0,1-3.5-3.5V34.21a.36.36,0,0,0-.33-.37l-1.46-.13a2.65,2.65,0,0,1-1.93-4.18l3.39-4.77a2,2,0,0,0,.35-1.07,14.39,14.39,0,0,1,5-10.3.79.79,0,0,1,1,1.21,12.79,12.79,0,0,0-4.43,9.17,3.6,3.6,0,0,1-.64,1.9L9.44,30.45a1.06,1.06,0,0,0-.1,1.06,1,1,0,0,0,.88.62l1.46.13a2,2,0,0,1,1.78,2V37a1.91,1.91,0,0,0,1.91,1.91h3a.8.8,0,0,1,0,1.59Zm4.79-15a.81.81,0,0,1-.63.31.77.77,0,0,1-.48-.16,3.21,3.21,0,0,0-4.12,0,.79.79,0,0,1-1-1.2,4.82,4.82,0,0,1,6.11,0A.79.79,0,0,1,23.13,25.47Z" />
			<path className="cls-1" d="M44,1H29.66a2.9,2.9,0,0,0-2.9,2.9v8.78a2.9,2.9,0,0,0,2.9,2.9h1.72v3.84a.53.53,0,0,0,.89.39l4-4.23H44a2.9,2.9,0,0,0,2.9-2.9V3.94A2.9,2.9,0,0,0,44,1ZM32.39,10a3,3,0,0,0,1.39-1.54,2,2,0,0,1-1.18-.84,2,2,0,0,1,.58-2.75,2,2,0,0,1,1-.32h0a.93.93,0,0,1,.24,0,2,2,0,0,1,1.48.88.61.61,0,0,1,.09.18.47.47,0,0,1,0,.1.77.77,0,0,1,.07.16h0s0,0,0,0a1.4,1.4,0,0,1,.08.34A5.35,5.35,0,0,1,33.47,12a1.34,1.34,0,0,1-.54.13h-.09A1.17,1.17,0,0,1,32.39,10ZM39,12a1.34,1.34,0,0,1-.54.13h-.09a1.22,1.22,0,0,1-1-.63A1.19,1.19,0,0,1,37.9,10a3,3,0,0,0,1.39-1.54,2,2,0,0,1-1.18-.84A2,2,0,0,1,39.67,4.5h0a.93.93,0,0,1,.24,0,2,2,0,0,1,1.48.88,1,1,0,0,1,.09.18.47.47,0,0,1,0,.1.77.77,0,0,1,.07.16h0s0,0,0,0a1,1,0,0,1,.07.34A5.33,5.33,0,0,1,39,12Z" />
			<path className="cls-1" d="M35.7,17.72a10.8,10.8,0,0,1,1.25,5c0,3.29-1.25,5.87-2.47,8.37-1,2.08-2,4-2,6.11a31.9,31.9,0,0,0,1.63,9.06.79.79,0,0,0,.75.54.85.85,0,0,0,.26,0,.79.79,0,0,0,.49-1A30.83,30.83,0,0,1,34.1,37.2c0-1.71.84-3.42,1.8-5.42,1.24-2.53,2.64-5.41,2.64-9.06a12.41,12.41,0,0,0-1.69-6.19Z" />
			<path className="cls-1" d="M25.76,10a13.79,13.79,0,0,0-2.47.25.78.78,0,0,0-.62.93.8.8,0,0,0,.93.62,11.22,11.22,0,0,1,2.16-.21Z" />
		</svg>
	);
};

export const Empathy = props => {
	return (
		<svg id='Empathy' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 48 48'}>
			<defs>
				<style>{`
					svg#Empathy .st0{fill:${props.color};}
				`}</style>
			</defs>

			<g>
				<g>
					<path className="st0" d="M38.7,34.69c-0.06-2.41,0.62-4.84,1.75-7.16c0.9-1.85,1.87-3.65,2.71-5.52c3.32-7.4-0.86-16-8.72-17.98
			c-1.53-0.38-3.08-0.52-4.66-0.38c-0.74,0.07-1.26-0.29-1.33-0.91c-0.07-0.64,0.36-1.12,1.13-1.18c8.41-0.67,15.5,5.14,16.59,12.9
			c0.43,3.07,0.03,6.01-1.29,8.81c-0.65,1.38-1.3,2.78-2.05,4.11c-2.18,3.87-2.56,7.95-1.52,12.2c0.44,1.77,0.97,3.51,1.46,5.27
			c0.06,0.23,0.14,0.48,0.12,0.71c-0.04,0.47-0.44,0.84-0.9,0.89c-0.48,0.05-0.93-0.18-1.09-0.65C39.84,42.7,38.66,38.39,38.7,34.69
			z"/>
				</g>
				<path className="st0" d="M37.28,24.53c-1.14-1.59-2.27-3.19-3.45-4.75c-0.43-0.56-0.61-1.12-0.6-1.83c0.04-2.95-0.75-5.7-2.24-8.24
		C27.5,3.76,20.77,0.56,14.28,1.75C4.28,3.6-1.15,14.07,3.14,23.29c0.87,1.87,1.84,3.71,2.73,5.57c0.9,1.88,1.38,3.86,1.39,5.95
		c0.01,1.82-0.24,3.61-0.69,5.37c-0.41,1.61-0.91,3.19-1.37,4.79C5.03,45.56,5.15,46,5.56,46.28c0.15,0.1,0.3,0.16,0.45,0.18l0,0
		l0,0c0.1,0.02,0.2,0.02,0.3,0l12.54,0.03v-9c-0.86-0.23-1.67-0.58-2.39-1.14c-1.12-0.89-1.67-2.06-1.71-3.48
		c-0.01-0.33,0-0.65,0-0.98c0.01,0,0.02,0,0.02,0c-0.02-0.49,0.11-1.09-0.12-1.43c-0.22-0.32-0.84-0.36-1.28-0.52
		c-0.4-0.14-0.8-0.27-1.2-0.42c-2.06-0.75-2.81-3.09-1.53-4.88c1.2-1.69,2.41-3.37,3.64-5.03c0.34-0.46,0.47-0.91,0.48-1.48
		c0.05-4.38,1.53-8.22,4.44-11.5c0.27-0.31,0.59-0.6,1-0.49c0.32,0.09,0.66,0.34,0.86,0.61c0.25,0.34,0.13,0.75-0.14,1.08
		c-0.34,0.42-0.71,0.81-1.04,1.23c-2.04,2.67-3.07,5.69-3.01,9.05c0.02,1.04-0.24,1.87-0.88,2.69c-1.23,1.58-2.33,3.27-3.55,4.85
		c-0.58,0.75-0.44,1.68,0.64,1.98c0.97,0.26,1.91,0.64,2.86,0.98c0.69,0.24,0.9,0.53,0.9,1.27c0,0.99-0.01,1.99,0,2.98
		c0.01,1.28,0.42,1.87,1.63,2.31c0.43,0.16,0.87,0.26,1.31,0.38c0.22,0.06,0.4,0.16,0.55,0.29c0.28,0.17,0.46,0.48,0.46,0.83v9.79
		l3.23,0.01v-0.01c0.44,0.03,0.86-0.22,1-0.63c0.07-0.21,0.08-0.45,0.08-0.67c0.01-2.19,0-4.37,0-6.56c0-0.19,0-0.38,0-0.61
		c0.41-0.03,0.76-0.06,1.12-0.09c1.65-0.15,3.27-0.43,4.72-1.27c1.49-0.87,2.27-2.16,2.25-3.9c0-0.57,0.04-1.15-0.01-1.71
		c-0.05-0.51,0.16-0.71,0.61-0.84c0.63-0.17,1.24-0.41,1.85-0.63C37.95,28.79,38.67,26.47,37.28,24.53z M9.35,34.77L9.35,34.77
		L9.35,34.77L9.35,34.77z M27.51,20.3c-1.08,0.62-2.26,0.9-3.38,0.91c-1.36,0-2.53-0.29-3.62-0.91c-0.64-0.37-0.85-0.96-0.54-1.51
		c0.31-0.55,0.93-0.68,1.57-0.31c1.65,0.96,3.3,0.96,4.95,0c0.64-0.37,1.25-0.24,1.56,0.31C28.36,19.34,28.16,19.93,27.51,20.3z"/>
			</g>
		</svg>
	);
};

export const Framing = props => {
	return (
		<svg id='Framing' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 48 48'}>
			<defs>
				<style>{`
					svg#Framing .st0{fill:none;stroke:${props.color};stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}
				`}</style>
			</defs>

			<g>
				<line className="st0" x1="32.79" y1="24.06" x2="15.41" y2="24.06" />
				<path className="st0" d="M42.11,32.03v8.39c0,0.93-0.76,1.69-1.69,1.69h-8.93" />
				<path className="st0" d="M5.89,32.03v8.39c0,0.93,0.76,1.69,1.69,1.69h8.93" />
				<path className="st0" d="M15.97,5.89H7.58c-0.93,0-1.69,0.76-1.69,1.69v8.93" />
				<path className="st0" d="M32.03,5.89h8.39c0.93,0,1.69,0.76,1.69,1.69v8.93" />
			</g>
		</svg>
	);
};

export const HVAC = props => {
	return (
		<svg id='HVAC' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 45.8 45.8'}>
			<defs>
				<style>{`
					svg#HVAC .cls-1{fill:${props.color};}
				`}</style>
			</defs>

			<g>
				<g>
					<path className="cls-1" d="M43,0H2.82A2.82,2.82,0,0,0,0,2.82v40.1a2.81,2.81,0,0,0,2.82,2.81H21.5c.47,0,.93.07,1.4.07s.94,0,1.4-.07H43a2.81,2.81,0,0,0,2.81-2.81V2.82A2.81,2.81,0,0,0,43,0ZM21.5,43.37A20.43,20.43,0,0,1,7.94,36.93c5.85,3.49,11.29-2.25,14.66-7.32a15.49,15.49,0,0,1-.34,4.32c-.88,4.27.91,7.87,3.78,9.25-.57.09-1.15.15-1.74.19ZM16.34,22.45A15.83,15.83,0,0,1,12,22.12c-4.41-.91-8.1,1-9.37,4.06a19.71,19.71,0,0,1-.29-3.28A20.48,20.48,0,0,1,9,7.82C5.56,13.66,11.28,19.09,16.34,22.45Zm3.81.45a2.9,2.9,0,1,1,2.9,2.9A2.9,2.9,0,0,1,20.15,22.9Zm9.61.46a15.07,15.07,0,0,1,4.32.33c4.18.86,7.7-.83,9.15-3.59a20,20,0,0,1,.21,2.8,20.47,20.47,0,0,1-6,14.52C40.19,31.8,34.66,26.61,29.76,23.36ZM23.5,16.19a15.49,15.49,0,0,1,.34-4.32C24.73,7.57,22.9,4,20,2.59a19.93,19.93,0,0,1,2.91-.23A20.48,20.48,0,0,1,37.55,8.52C31.93,5.78,26.75,11.3,23.5,16.19Z" />
				</g>
			</g>
		</svg>
	);
};

export const Insulation = props => {
	return (
		<svg id='Insulation' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 41.21 45.85'}>
			<defs>
				<style>{`
					svg#Insulation .cls-1{fill:${props.color};}
				`}</style>
			</defs>

			<g>
				<g>
					<rect className="cls-1" width="3.16" height="45.85" rx="1.5" />
					<rect className="cls-1" x="6.35" width="3.16" height="45.85" />
					<rect className="cls-1" x="31.69" width="3.16" height="45.85" />
					<rect className="cls-1" x="38.05" width="3.16" height="45.85" rx="1.33" />
					<rect className="cls-1" x="18.9" y="-18.9" width="3.37" height="41.18" rx="1.48" transform="matrix(0, 1, -1, 0, 22.27, -18.9)" />
					<rect className="cls-1" x="18.9" y="23.58" width="3.37" height="41.18" rx="1.48" transform="matrix(0, 1, -1, 0, 64.76, 23.58)" />
					<rect className="cls-1" x="13.35" y="32.1" width="6.31" height="2.65" rx="1" />
					<rect className="cls-1" x="21.8" y="26.81" width="6.31" height="2.65" rx="1" />
					<rect className="cls-1" x="21.8" y="37.01" width="6.31" height="2.65" rx="1" />
					<rect className="cls-1" x="13.35" y="21.52" width="6.31" height="2.65" rx="1" />
					<rect className="cls-1" x="21.8" y="16.23" width="6.31" height="2.65" rx="1" />
					<rect className="cls-1" x="13.35" y="10.94" width="6.31" height="2.65" rx="1" />
					<rect className="cls-1" x="21.8" y="5.65" width="6.31" height="2.65" rx="1" />
				</g>
			</g>
		</svg>
	);
};

export const Motivating = props => {
	return (
		<svg id='Motivating' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 45.49 45.83'}>
			<defs>
				<style>{`
					svg#Motivating .cls-1{fill:${props.color};}
				`}</style>
			</defs>

			<g>
				<g>
					<path className="cls-1" d="M17.06,1.64a.13.13,0,0,0,0-.06.13.13,0,0,0,0-.06s0,0,0-.06l0-.05a.08.08,0,0,0,0,0,.21.21,0,0,0,0-.06v0s0,0,0,0l-.05-.05s0,0,0,0l-.05,0-.05,0-.06,0-.06,0h-.35l-.06,0-.05,0-.06,0h0L13.14,3.47l-1.7-3a.61.61,0,0,0-.53-.31.63.63,0,0,0-.54.31l-1.7,3L5.75,1.18h0l-.06,0,0,0-.06,0H5.21l-.06,0-.05,0,0,0,0,0,0,0,0,.05,0,0v0l0,.06,0,0a.08.08,0,0,0,0,.05.14.14,0,0,0,0,.06.13.13,0,0,0,0,.06s0,0,0,.06V7.43A1.85,1.85,0,0,0,6.6,9.28h8.62a1.85,1.85,0,0,0,1.84-1.85V1.64Z" />
					<path className="cls-1" d="M38.24,33A8.47,8.47,0,1,0,25.85,33a12,12,0,0,0-7.4,11,1.82,1.82,0,0,0,1.82,1.83H43.66A1.83,1.83,0,0,0,45.49,44,11.94,11.94,0,0,0,38.24,33Z" />
					<path className="cls-1" d="M21.81,31.78a9.66,9.66,0,0,0-5.37-8.65,7,7,0,1,0-11-.06A9.68,9.68,0,0,0,0,31.78a1.83,1.83,0,0,0,1.83,1.83H20A1.83,1.83,0,0,0,21.81,31.78Z" />
					<path className="cls-1" d="M32,16.06a1.23,1.23,0,0,1-.87-.36l-2.18-2.18a.55.55,0,0,0-.39-.16H25.74a3,3,0,0,1-3-3V3a3,3,0,0,1,3-3H38.2a3,3,0,0,1,3,3v7.34a3,3,0,0,1-3,3H35.41a.59.59,0,0,0-.4.16L32.84,15.7A1.24,1.24,0,0,1,32,16.06ZM25.74,2.45a.56.56,0,0,0-.55.56v7.34a.56.56,0,0,0,.55.56h2.79a3,3,0,0,1,2.13.88L32,13.1l1.31-1.31a3,3,0,0,1,2.13-.88H38.2a.56.56,0,0,0,.55-.56V3a.56.56,0,0,0-.55-.56Z" />
					<path className="cls-1" d="M35.48,4.72V4.65l0,0a0,0,0,0,0,0,0s0,0,0,0l0,0h0v0l0,0,0,0,0,0h0l0,0H35l0,0,0,0h0l-1.67,1.3-1-1.69a.35.35,0,0,0-.3-.18.37.37,0,0,0-.31.18l-1,1.69L29,4.46h0l0,0,0,0h-.27l0,0h0l0,0,0,0,0,0v0h0l0,0,0,0a0,0,0,0,1,0,0s0,0,0,0v0a.06.06,0,0,0,0,0h0V8a1.05,1.05,0,0,0,1.06,1.05h4.92A1.06,1.06,0,0,0,35.49,8V4.73Z" />
				</g>
			</g>
		</svg>
	);
};

export const NaturalParaphrase = props => {
	return (
		<svg id='NaturalParaphrase' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 48 48'}>
			<defs>
				<style>{`
					svg#NaturalParaphrase .st0{fill:${props.color};}
				`}</style>
			</defs>

			<path className="st0" d="M39.19,4.02H8.81c-3.41,0-6.17,2.76-6.17,6.17v18.66c0,3.41,2.76,6.17,6.17,6.17h3.82v7.87
	c0,0.95,1.12,1.44,1.81,0.8l8.29-8.67h16.46c3.41,0,6.17-2.76,6.17-6.17V10.19C45.36,6.78,42.6,4.02,39.19,4.02z M16.9,27.39
	c-0.37,0.19-0.76,0.27-1.14,0.27c-0.9,0-1.77-0.49-2.21-1.34c-0.63-1.22-0.15-2.72,1.07-3.35c1.39-0.72,2.41-1.9,2.96-3.28
	c-1-0.24-1.91-0.84-2.52-1.77c-1.28-1.96-0.73-4.58,1.23-5.85c1.95-1.28,4.57-0.73,5.85,1.23c0.08,0.12,0.13,0.25,0.19,0.38
	c0.04,0.07,0.08,0.14,0.12,0.21c0.05,0.11,0.09,0.22,0.13,0.34c0,0,0,0.01,0.01,0.02c0,0.01,0,0.02,0.01,0.04
	c0.08,0.24,0.14,0.48,0.17,0.73C23.81,19.95,21.43,25.05,16.9,27.39z M28.61,27.39c-0.37,0.19-0.76,0.27-1.14,0.27
	c-0.9,0-1.77-0.49-2.21-1.34c-0.63-1.22-0.15-2.72,1.07-3.35c1.39-0.72,2.41-1.9,2.96-3.28c-1-0.24-1.91-0.84-2.52-1.77
	c-1.28-1.96-0.73-4.58,1.23-5.85c1.95-1.28,4.57-0.73,5.85,1.23c0.08,0.12,0.13,0.25,0.19,0.38c0.04,0.07,0.08,0.14,0.12,0.21
	c0.04,0.11,0.09,0.22,0.13,0.34c0,0,0,0.01,0.01,0.02c0,0.01,0,0.02,0.01,0.04c0.08,0.24,0.14,0.48,0.17,0.73
	C35.52,19.95,33.14,25.05,28.61,27.39z"/>
		</svg>
	);
};

export const PositiveReinforcement = props => {
	return (
		<svg id='PositiveReinforcement' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 48 48'}>
			<defs>
				<style>{`
					svg#PositiveReinforcement .st0{fill:${props.color};}
				`}</style>
			</defs>

			<g>
				<path className="st0" d="M3.36,16.56h5.99c1.57,0,2.84,1.27,2.84,2.84v21.97c0,1.34-1.09,2.43-2.43,2.43h-6.4
		c-1.34,0-2.43-1.09-2.43-2.43V18.99C0.94,17.65,2.02,16.56,3.36,16.56z"/>
				<path className="st0" d="M47,23.24c-0.31,1.56-1.56,2.69-3.05,2.89c1.31,0.7,2.07,2.18,1.77,3.72c-0.31,1.58-1.63,2.7-3.16,2.8
		c1.39,0.58,2.22,2.08,1.93,3.62c-0.28,1.46-1.49,2.5-2.9,2.63c0.79,0.7,1.9,2.52,0.18,4.54c-3.3,3.39-26.89-1.36-26.89-1.36
		l0.09-23.56C22.39,13.93,22,9.51,22.3,6.4c0.2-2.1,2.27-3.55,4.29-2.91c6.57,2.08,4.32,11.25,3.11,14.67l0,0
		c9.33-0.28,12.15,0.35,14.43,0.85l0,0C46.09,19.39,47.37,21.27,47,23.24z"/>
			</g>
		</svg>
	);
};

export const ProbingQuestions = props => {
	return (
		<svg id='ProbingQuestions' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 46.72 45.92'}>
			<defs>
				<style>{`
					svg#ProbingQuestions .cls-1{fill:${props.color};}
				`}</style>
			</defs>

			<g>
				<g>
					<path className="cls-1" d="M39.71,0H7C3.14,0,0,3.42,0,7.63V30.05c0,4.21,3.14,7.64,7,7.64h7.33a2,2,0,0,1,1.49.77l5.72,6.65a2.43,2.43,0,0,0,3.62,0l5.72-6.65a2,2,0,0,1,1.5-.77h7.32c3.87,0,7-3.43,7-7.64V7.63C46.72,3.42,43.58,0,39.71,0ZM24.87,30.8a2.54,2.54,0,0,1-1.71.62,2.66,2.66,0,0,1-1.74-.61,2.07,2.07,0,0,1-.74-1.71,2.12,2.12,0,0,1,.72-1.63,2.48,2.48,0,0,1,1.76-.67,2.42,2.42,0,0,1,1.74.67,2.13,2.13,0,0,1,.7,1.63A2.1,2.1,0,0,1,24.87,30.8ZM31,16.49a7.15,7.15,0,0,1-1.34,1.71c-.52.48-1.45,1.28-2.79,2.42a11,11,0,0,0-.89.84,3,3,0,0,0-.5.67,3.11,3.11,0,0,0-.26.6c-.06.2-.15.55-.27,1.06A1.78,1.78,0,0,1,23,25.39a2.07,2.07,0,0,1-1.43-.52A2,2,0,0,1,21,23.31a5.35,5.35,0,0,1,.43-2.25,5.53,5.53,0,0,1,1.13-1.67,24.36,24.36,0,0,1,1.89-1.71c.7-.58,1.21-1,1.52-1.3a5,5,0,0,0,.79-1A2.28,2.28,0,0,0,27,14.22a2.66,2.66,0,0,0-1-2.09,3.72,3.72,0,0,0-2.51-.85,3.59,3.59,0,0,0-2.65.86,6.61,6.61,0,0,0-1.44,2.53,2.14,2.14,0,0,1-2.12,1.74,2.11,2.11,0,0,1-1.54-.61,1.8,1.8,0,0,1-.63-1.32,5.31,5.31,0,0,1,1-3A7.44,7.44,0,0,1,19.09,9a9.62,9.62,0,0,1,4.47-1,10,10,0,0,1,4.19.83,6.67,6.67,0,0,1,2.8,2.25,5.29,5.29,0,0,1,1,3.09A4.53,4.53,0,0,1,31,16.49Z" />
				</g>
			</g>
		</svg>
	);
};

export const ResolvingIssues = props => {
	return (
		<svg id='ResolvingIssues' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 36.89 45.06'}>
			<defs>
				<style>{`
					svg#ResolvingIssues .cls-1{fill:${props.color};}
				`}</style>
			</defs>

			<g>
				<g>
					<path className="cls-1" d="M35.44,6.32,19.25.15a2.24,2.24,0,0,0-1.61,0L1.45,6.32A2.28,2.28,0,0,0,0,8.43V21.05A25.12,25.12,0,0,0,17.8,45a2.13,2.13,0,0,0,1.29,0,25.12,25.12,0,0,0,17.8-23.91V8.43A2.28,2.28,0,0,0,35.44,6.32Zm-7.84,12-9.31,9.31-.16.13-.17.14a1.71,1.71,0,0,1-.23.13l-.17.09c-.09,0-.19.06-.28.09l-.14,0a2.28,2.28,0,0,1-.45,0h0a1.84,1.84,0,0,1-.41,0l-.13,0c-.09,0-.19-.05-.28-.09l-.15-.07a1.67,1.67,0,0,1-.23-.12l-.15-.11-.16-.13L10,23a2.25,2.25,0,1,1,3-3.33L16.62,23l7.8-7.8a2.25,2.25,0,0,1,3.18,3.19Z" />
				</g>
			</g>
		</svg>
	);
};

export const Respectfulness = props => {
	return (
		<svg id='Respectfulness' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 48 48'}>
			<defs>
				<style>{`
					svg#Respectfulness .cls-1{fill:${props.color};}
				`}</style>
			</defs>

			<rect className="cls-1" x="20.51" y="33.96" width="7.66" height="11.4" rx="3.83" transform="translate(13.51 84.91) rotate(-135)" />
			<rect className="cls-1" x="16.41" y="29.86" width="7.66" height="11.4" rx="3.83" transform="translate(9.41 75.01) rotate(-135)" />
			<rect className="cls-1" x="12.32" y="25.76" width="7.66" height="11.4" rx="3.83" transform="translate(5.32 65.12) rotate(-135)" />
			<rect className="cls-1" x="8.22" y="21.66" width="7.66" height="11.4" rx="3.83" transform="translate(1.22 55.22) rotate(-135)" />
			<path className="cls-1" d="M42.69,7.16a13.66,13.66,0,0,0-18.83-.43A13.64,13.64,0,0,0,5,26.46a1,1,0,1,0,1.42-1.41,11.64,11.64,0,0,1,16-16.93l-8.61,8.61a1,1,0,0,0,0,1.41c2.53,2.53,7,2.9,9.57.37l4.73-4.74,1,1h0L39.79,25.48a1.84,1.84,0,0,1-2.6,2.6.24.24,0,0,0-.08-.06L28.3,19.21a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42l8.88,8.87a1.83,1.83,0,0,1-2.51,2.67l-.07-.09a.53.53,0,0,0-.1-.06l-8.8-8.8a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42l8.87,8.87.1.08a1.83,1.83,0,0,1-.08,2.5l-.79.8a1,1,0,0,0,0,1.41,1,1,0,0,0,1.41,0l.8-.79a3.81,3.81,0,0,0,1.1-2.89l.18,0a3.82,3.82,0,0,0,3.81-4.05l.21,0a3.82,3.82,0,0,0,3.83-3.78l.37-.37a13.64,13.64,0,0,0,0-19.3Z" />
		</svg>
	);
};

export const VerbalCommunication = props => {
	return (
		<svg id='VerbalCommunication' data-name='Layer 1' width={props.width} height={props.height} viewBox={'0 0 48 48'}>
			<defs>
				<style>{`
					svg#VerbalCommunication .cls-1{fill:${props.color};}
				`}</style>
			</defs>

			<path className="cls-1" d="M41.57,17.12h-3.7V27.85a4.93,4.93,0,0,1-4.93,4.93H19.12A4.92,4.92,0,0,0,24,36.88h9.26l0,0,5.63,5.65A.87.87,0,0,0,40.37,42V36.88h1.2A4.93,4.93,0,0,0,46.5,32V22.05A4.93,4.93,0,0,0,41.57,17.12Z" />
			<path className="cls-1" d="M31.44,6.17h-25A4.93,4.93,0,0,0,1.5,11.1V26.38a4.93,4.93,0,0,0,4.93,4.93H9.49V38A.87.87,0,0,0,11,38.6l7.26-7.29H31.44a4.93,4.93,0,0,0,4.93-4.93V11.1A4.93,4.93,0,0,0,31.44,6.17ZM22.61,22.61H9.54a1,1,0,0,1,0-2H22.61a1,1,0,0,1,0,2Zm6.15-6H9.54a1,1,0,1,1,0-2H28.76a1,1,0,0,1,0,2Z" />
		</svg>
	);
};

export const Closing = props => {
	return (
		<svg viewBox="0 0 58.38 49.88" {...props}>
			<path
				d="M58.27 21.28L50.72.78a1.19 1.19 0 00-.64-.72.81.81 0 00-.83.14L44 4.46a1.84 1.84 0 00-.43 2l.1.28-.55.41A3.21 3.21 0 0138.75 7l-2.08-2a4.71 4.71 0 00-3.21-1.35h-4.84a3.37 3.37 0 00-2.39 1.1l-1.51-.69a2.54 2.54 0 00-2.63.6L19.64 7a3.22 3.22 0 01-4.31.2l-.55-.47.09-.23a1.86 1.86 0 00-.44-2L9.14.2a.82.82 0 00-.83-.14 1.22 1.22 0 00-.65.73L.12 21.29a1.86 1.86 0 00.43 2l5.29 4.26a.88.88 0 00.54.2.93.93 0 00.29 0 1.22 1.22 0 00.65-.75v-.13l1 .8a3.24 3.24 0 011.06 1.89l.44 1.77-.47 1.27a5.58 5.58 0 00-.25 3.46 4.79 4.79 0 001.65 2.69 2.87 2.87 0 002.31.6 4.89 4.89 0 001.7 3.25 2.7 2.7 0 002.83.37 4.55 4.55 0 001.57 2.54 2.67 2.67 0 002.83.36 4.54 4.54 0 001.57 2.55 2.76 2.76 0 001.71.61 2.6 2.6 0 00.94-.17 3.44 3.44 0 001.42-1.09l1.79 1.44a2.78 2.78 0 001.78.67 2.87 2.87 0 00.86-.14 3.8 3.8 0 002.14-2.14 5.7 5.7 0 00.47-1.9 2.58 2.58 0 002.15.2A3.74 3.74 0 0039 43.76a5.71 5.71 0 00.47-1.89c1.57.85 3.4.06 4.29-1.94A6 6 0 0044.2 38a2.62 2.62 0 002.15.2 3.74 3.74 0 002.14-2.14 6 6 0 00.39-3.55 5.81 5.81 0 00-.31-1.05l.36-2a3.22 3.22 0 011-1.85l1.05-.8v.11a1.18 1.18 0 00.64.73.72.72 0 00.29.06.88.88 0 00.54-.2l5.29-4.26a1.86 1.86 0 00.53-1.97zM11.15 34l2.12-5a1.21 1.21 0 01.76-.71.92.92 0 01.29 0 1.29 1.29 0 01.78.28 2.12 2.12 0 01.63 2.35l-2.13 5a1.14 1.14 0 01-1.82.47 2.09 2.09 0 01-.63-2.39zm8.5 6.52L22 35a1.51 1.51 0 01.85-.88 1 1 0 01.38-.08 1.15 1.15 0 01.69.25 2.28 2.28 0 01.53 2.59l-2.31 5.48c-.39.91-1.25 1.23-1.93.71a1.87 1.87 0 01-.66-1.14 2.51 2.51 0 01.1-1.43zm-4.4-2.91l2.88-6.81a1.57 1.57 0 01.84-.89 1.34 1.34 0 01.39-.07 1.15 1.15 0 01.69.25 1.87 1.87 0 01.66 1.14 2.39 2.39 0 01-.13 1.45l-2.87 6.8c-.39.91-1.25 1.23-1.93.71a2.29 2.29 0 01-.53-2.6zm8.8 5.82l1.39-3.29a1.41 1.41 0 011.23-1 1.13 1.13 0 01.69.25 2.28 2.28 0 01.53 2.61l-1.39 3.29a1.52 1.52 0 01-.84.88 1.09 1.09 0 01-1.08-.17 1.89 1.89 0 01-.66-1.15 2.43 2.43 0 01.13-1.44zM45.74 6.25l3.62-2.91L56 21.49l-3.58 2.91m-3.49.83a6.05 6.05 0 00-2 3.53l-.09.53-18.92-15.21a.94.94 0 00-1.23 0l-1 .77c-.4.32-1 .79-1.57 1.16a5 5 0 01-2.38.72c-1.36.1-2.12-.18-2.26-.49-.05-.12-.07-.16.07-.31l7.81-8.84a1.65 1.65 0 011.23-.61h4.84a3 3 0 012 .85l2.09 1.93a4.87 4.87 0 006.55.29l.3-.23.11-.08 5.62 15.1zm-36.29-19L6 24.4l-3.66-2.91L9 3.34zM14.51 9zm-5 16.27l-1.17-.92L13.86 9.2l.1.09.3.25a4.92 4.92 0 003.11 1.16 5.06 5.06 0 003.44-1.44L23.27 7a.89.89 0 01.81-.23l.25.14-6.09 6.89a3.68 3.68 0 00-.51 3.87c.62 1.42 2 2 4.16 1.85a6.53 6.53 0 003.17-1c.61-.4 1.24-.88 1.72-1.26l.52-.42 18.93 15.22a1.93 1.93 0 01.64 1.16 2.52 2.52 0 01-.16 1.44 1.23 1.23 0 01-1.93.66l-2.23-1.8-2.86-2.3a.9.9 0 00-1.42.48 1.71 1.71 0 00.36 1.92l2.83 2.27a1.92 1.92 0 01.64 1.17 2.43 2.43 0 01-.1 1.44 1.24 1.24 0 01-1.94.65l-2.25-1.81-1.89-1.53a.82.82 0 00-.79-.15 1.08 1.08 0 00-.63.63 1.74 1.74 0 00-.12 1.06 1.46 1.46 0 00.47.86l1.91 1.53a2.29 2.29 0 01.47 2.59 1.53 1.53 0 01-.86.87 1.11 1.11 0 01-1.12-.2L33 41.21l-1-.81a.81.81 0 00-.78-.15 1.09 1.09 0 00-.64.64A1.7 1.7 0 0031 42.8l1 .78a2.33 2.33 0 01.47 2.59 1.23 1.23 0 01-1.94.65l-1.67-1.35.88-2.09c.95-2.25.37-5.12-1.3-6.39a2.85 2.85 0 00-1.72-.61 5.33 5.33 0 00-1.74-4.5 2.72 2.72 0 00-2.1-.58 5.58 5.58 0 00-.11-.82 4.71 4.71 0 00-1.63-2.83 2.76 2.76 0 00-3.63.15 4.52 4.52 0 00-1.33-1.74 2.76 2.76 0 00-2.62-.51 3.41 3.41 0 00-2 2l-.2.47a6.5 6.5 0 00-1.9-2.78z"
				fill={`${props.color}`}
				data-name="Layer 2"
			/>
		</svg>
	);
};

export const Company = props => {
	return (
		<svg viewBox="0 0 53.25 47.18" {...props}>
			<defs>
				<style>{`.cls-1{fill:${props.color}}`}</style>
			</defs>
			<g id="Layer_2" data-name="Layer 2">
				<g id="Layer_2-2" data-name="Layer 2">
					<path
						className="cls-1"
						d="M50.55 43.81V14.49h-8.76V0H11.46v14.49H2.7v29.32H0v3.37h53.25v-3.37zm-44.48 0V17.86h5.39v26zm19.54 0h-5.39v-8.76h5.39zm7.42 0h-5.39v-8.76H33zm5.39-27.63v27.63h-3.37V33H18.2v10.81h-3.37V3.37h23.59zm8.76 27.63h-5.39V17.86h5.39z"
					/>
					<path
						className="cls-1"
						d="M24.94 26.62H28.310000000000002V29.990000000000002H24.94z"
					/>
					<path
						className="cls-1"
						d="M31.68 26.62H35.05V29.990000000000002H31.68z"
					/>
					<path
						className="cls-1"
						d="M18.2 26.62H21.57V29.990000000000002H18.2z"
					/>
					<path
						className="cls-1"
						d="M24.94 19.88H28.310000000000002V23.25H24.94z"
					/>
					<path className="cls-1" d="M31.68 19.88H35.05V23.25H31.68z" />
					<path className="cls-1" d="M18.2 19.88H21.57V23.25H18.2z" />
					<path
						className="cls-1"
						d="M24.94 13.14H28.310000000000002V16.51H24.94z"
					/>
					<path className="cls-1" d="M31.68 13.14H35.05V16.51H31.68z" />
					<path className="cls-1" d="M18.2 13.14H21.57V16.51H18.2z" />
					<path
						className="cls-1"
						d="M24.94 6.4H28.310000000000002V9.77H24.94z"
					/>
					<path className="cls-1" d="M31.68 6.4H35.05V9.77H31.68z" />
					<path className="cls-1" d="M18.2 6.4H21.57V9.77H18.2z" />
				</g>
			</g>
		</svg>
	);
};

export const CyberSecurity = props => {
	return (
		<svg viewBox="0 0 40.32 49.84" {...props}>
			<defs>
				<style>{`.cls-1{fill:${props.color}`}</style>
			</defs>
			<g id="Layer_2" data-name="Layer 2">
				<g id="Layer_2-2" data-name="Layer 2">
					<path
						className="cls-1"
						d="M11.95 25.97L21.61 27.54 18.85 38.66 28.37 23.07 18.91 21.54 20.17 12.44 11.95 25.97z"
					/>
					<path
						className="cls-1"
						d="M20.16 0l-14 5.35L0 7.69v15.58a27.84 27.84 0 0019.69 26.49 1.52 1.52 0 00.42.06 1.45 1.45 0 00.41-.06h.05a27.85 27.85 0 0019.75-26.49V7.69zm17.2 23.27a24.87 24.87 0 01-17.2 23.54A24.88 24.88 0 013 23.27V9.72l4.18-1.61 13-4.95 17.2 6.56z"
					/>
				</g>
			</g>
		</svg>
	);
};

export const Efficiency = props => {
	return (
		<svg viewBox="0 0 45.52 45.03" {...props}>
			<defs>
				<style>{`.cls-1{fill:${props.color}}`}</style>
			</defs>
			<g id="Layer_2" data-name="Layer 2">
				<g id="Layer_2-2" data-name="Layer 2">
					<path
						className="cls-1"
						d="M24.49 19.38v-5.3a1.73 1.73 0 10-3.46 0v5.3a3.9 3.9 0 103.46 0z"
					/>
					<path
						className="cls-1"
						d="M45.51 22.11A22.75 22.75 0 000 22.17a.36.36 0 000 .1v5.49h6.83a18.55 18.55 0 00.79 1.9l-4.83 4.83 7.76 7.75 4.82-4.82a16.69 16.69 0 001.91.79V45h11v-6.79a16.55 16.55 0 001.9-.79L35 42.24l7.75-7.75-4.82-4.83a16.48 16.48 0 00.78-1.9h6.83v-5.49a.453.453 0 01-.03-.16zm-2.94 2.69h-6.1l-.29 1.1a14.28 14.28 0 01-1.37 3.3l-.56 1 4.31 4.31L35 38.07l-4.31-4.31-1 .56a13.89 13.89 0 01-3.31 1.38l-1.08.3v6.08h-5.07V36l-1.09-.3a13.82 13.82 0 01-3.3-1.38l-1-.56-4.31 4.31L7 34.49l4.31-4.31-.57-1a13.83 13.83 0 01-1.36-3.3l-.3-1.1H3v-2.1a19.81 19.81 0 0139.61.08z"
					/>
				</g>
			</g>
		</svg>
	);
};

export const UncoveringOpportunities = props => {
	return (
		<svg viewBox="0 0 59.79 43.79" {...props}>
			<defs>
				<style>{`.cls-1{fill:${props.color}}`}</style>
			</defs>
			<g id="Layer_2" data-name="Layer 2">
				<g id="Layer_2-2" data-name="Layer 2">
					<path
						className="cls-1"
						d="M59.5 11.5A14.31 14.31 0 0041.76.49 14.37 14.37 0 0036 3.61H8.47L0 17.75l22.21 25.56L37.24 26l.29.22a14.25 14.25 0 007.91 2.4c.45 0 .9 0 1.36-.07l3.05 15.22 2.9-.58L49.7 28a14.31 14.31 0 009.8-16.5zm-26-5a14.11 14.11 0 00-2.18 9.58h-2l-3-9.58zM3.63 17.43l6.52-10.89h13a1.29 1.29 0 000 .19l3 9.39H23a1.48 1.48 0 100 2.95h3.2l-5.39 17.82a1.05 1.05 0 00-.06.24zM23.9 36.87l5.39-17.8H32a14.23 14.23 0 003 5zm31-16.26a11.37 11.37 0 01-15.75 3.18 11.54 11.54 0 01-4-4.71 12 12 0 01-.83-2.52c0-.14 0-.29-.06-.43a11.27 11.27 0 011.32-7.4c.14-.23.27-.47.42-.7a11.57 11.57 0 011.52-1.81A11.35 11.35 0 0145.46 3a11.37 11.37 0 019.47 17.66z"
					/>
					<path
						className="cls-1"
						d="M17.94 16.12h-1.18a1.48 1.48 0 100 2.95h1.18a1.48 1.48 0 000-2.95z"
					/>
				</g>
			</g>
		</svg>
	);
};

export const Internet = props => {
	return (
		<svg viewBox="0 0 41.96 41.96" {...props}>
			<path
				d="M42 21A21 21 0 0021 0 20.75 20.75 0 008.81 3.89a16.47 16.47 0 00-4.1 3.84 21 21 0 0015.82 34.21h.91A21 21 0 0042 21zm-3-1.39a1.51 1.51 0 00-.48-.08h-8.2a31.77 31.77 0 00-5.63-16.19 18.05 18.05 0 0114.25 16.25zm-11.71 2.85c-.4 6-3.12 13.09-6.31 16.31-3.19-3.22-5.91-10.28-6.31-16.31m0-2.95A28 28 0 0121 3.37a28.08 28.08 0 016.3 16.14zM7 9.58a13.72 13.72 0 013.43-3.22 17.93 17.93 0 016.8-3 31.69 31.69 0 00-5.56 16.16H3.5a1.37 1.37 0 00-.5.08A18.16 18.16 0 017 9.58zM3 22.37a1.51 1.51 0 00.48.09h8.21a34.38 34.38 0 005.35 16.11A18.05 18.05 0 013 22.37zm21.89 16.2a34.26 34.26 0 005.34-16.11h8.21a1.51 1.51 0 00.48-.09 18 18 0 01-14.01 16.2z"
				fill={`${props.color}`}
				data-name="Layer 2"
			/>
		</svg>
	);
};

export const Mobility = props => {
	return (
		<svg viewBox="0 0 52.39 43.25" {...props}>
			<defs>
				<style>{`.cls-1{fill:${props.color}}`}</style>
			</defs>
			<g id="Layer_2" data-name="Layer 2">
				<g id="Layer_2-2" data-name="Layer 2">
					<path
						className="cls-1"
						d="M47.91 11.92h-4.82V1.48A1.47 1.47 0 0041.62 0H5a1.47 1.47 0 00-1.43 1.48v24l-3.47 9a1.45 1.45 0 00.16 1.42 1.47 1.47 0 001.22.64h31.39v2.23a4.48 4.48 0 004.47 4.48h10.57a4.49 4.49 0 004.48-4.48V16.39a4.48 4.48 0 00-4.48-4.47zM6.52 3h33.62v9h-2.8a4.47 4.47 0 00-4.47 4.47v7.93H6.52zM3.63 33.59l2.43-6.32h26.81v6.32zm45.81 5.18a1.53 1.53 0 01-1.53 1.52H37.34a1.52 1.52 0 01-1.52-1.52V16.39a1.52 1.52 0 011.52-1.52h10.57a1.53 1.53 0 011.53 1.52z"
					/>
					<path
						className="cls-1"
						d="M42.63 35a1.85 1.85 0 00-1.82 1.57 2.45 2.45 0 000 .27 1.84 1.84 0 103.68 0 2.48 2.48 0 000-.27A1.83 1.83 0 0042.63 35z"
					/>
				</g>
			</g>
		</svg>
	);
};

export const Thoroughness = props => {
	return (
		<svg viewBox="0 0 52.27 47.93" {...props}>
			<defs>
				<style>{`.cls-1{fill:${props.color}}`}</style>
			</defs>
			<g id="Layer_2" data-name="Layer 2">
				<g id="Layer_2-2" data-name="Layer 2">
					<path
						className="cls-1"
						d="M51.22 25.05a14.25 14.25 0 00-11.79-19.6V0H0v47.93h39.43v-14a14.31 14.31 0 002.68-.54l6 14.31 2.72-1.16-6.05-14.3a14.21 14.21 0 006.44-7.19zM3 45V3h33.48v2.5a14.14 14.14 0 00-4.93 1.41 14.28 14.28 0 00-6.64 7H7.9v3H24a14 14 0 000 5.73H7.9v3h17a14.28 14.28 0 007.71 7.5 14.45 14.45 0 003.91 1V45zm30.68-14.8a11.37 11.37 0 01-.81-20.7A11.49 11.49 0 0138 8.31a11.26 11.26 0 014.26.83 11.36 11.36 0 11-8.58 21.06z"
					/>
					<path
						className="cls-1"
						d="M7.9 31.17H21.509999999999998V34.120000000000005H7.9z"
					/>
				</g>
			</g>
		</svg>
	);
};

export const Voice = props => {
	return (
		<svg viewBox="0 0 44.59 45.09" {...props}>
			<defs>
				<style>{`.cls-1{fill:${props.color}}`}</style>
			</defs>
			<g id="Layer_2" data-name="Layer 2">
				<g id="Layer_2-2" data-name="Layer 2">
					<path
						className="cls-1"
						d="M39 .27a1.47 1.47 0 10-1.7 2.41 10 10 0 010 16.47 1.48 1.48 0 00.85 2.69 1.48 1.48 0 00.85-.27 13 13 0 000-21.3zM7.25 19.15a10 10 0 010-16.47A1.47 1.47 0 105.55.27a13 13 0 000 21.3 1.48 1.48 0 002.06-.36 1.49 1.49 0 00-.36-2.06z"
					/>
					<path
						className="cls-1"
						d="M33.46 15a1.48 1.48 0 101.69 2.42 8 8 0 000-13 1.48 1.48 0 00-1.69 2.42 5 5 0 010 8.21zM9.44 17.44A1.47 1.47 0 1011.13 15a5 5 0 010-8.22 1.48 1.48 0 00-1.69-2.39 8 8 0 000 13.05zM22.29 34.53a7 7 0 007-6.94v-13a6.95 6.95 0 00-13.89 0v13a7 7 0 006.89 6.94zm-4-20a4 4 0 118 0v13a4 4 0 11-8 0z"
					/>
					<path
						className="cls-1"
						d="M22.29 39.06a11.41 11.41 0 01-11.4-11.4H7.94a14.38 14.38 0 0012.88 14.28v3.15h2.95v-3.15a14.38 14.38 0 0012.88-14.28H33.7a11.42 11.42 0 01-11.41 11.4z"
					/>
				</g>
			</g>
		</svg>
	);
};

// const icons = {
// 	ActiveListening: ActiveListening,
// 	Adaptability: Adaptability,
// 	Anchoring: Anchoring,
// 	Closing: Closing,
// 	ConflictResolution: ConflictResolution,
// 	ConstructionCarpentry: BasicCarpentry,
// 	ConstructionDrywall: Drywall,
// 	ConstructionElectrical: Electricity,
// 	ConstructionFlooring: BasicFlooring,
// 	ConstructionFraming: BasicFraming,
// 	ConstructionHVAC: HVAC,
// 	ConstructionInsulation: Insulation,
// 	ConstructionPainting: BasicPainting,
// 	ConstructionPlumbing: BasicPlumbing,
// 	ConstructionRoofing: BasicRoofing,
// 	ConstructionSiding: BasicSiding,
// 	ConstructionWallpaper: BasicWallpsper,
// 	ConstructiveFeedback: ConstructiveFeedback,
// 	Company: Company,
// 	Cybersecurity: CyberSecurity,
// 	Efficiency: Efficiency,
// 	EmpatheticParaphrase: EmpatheticParaphrase,
// 	Empathy: Empathy,
// 	UncoveringOpportunities: UncoveringOpportunities,
// 	Framing: Framing,
// 	Internet: Internet,
// 	ManagingDifficultConversations: DifficultConversation,
// 	Mobility: Mobility,
// 	Motivating: Motivating,
// 	NaturalParaphrase: NaturalParaphrase,
// 	PositiveReinforcement: PositiveReinforcement,
// 	ProbingQuestions: ProbingQuestions,
// 	ResolvingIssues: ResolvingIssues,
// 	Respectfulness: Respectfulness,
// 	Thoroughness: Thoroughness,
// 	VerbalCommunication: VerbalCommunication,
// 	Voice: Voice,

// 	Bonus: null,
// 	EvokingQuestion: null,
// 	MilitaryAddress: null,
// 	RiskAwareness: null
// };

const DEFAULT_WIDTH = 40;
const DEFAULT_HEIGHT = 40;

const SkillIcon = props => {
	const theme = useTheme();
	const { record } = props;
	const width =
		props.width && props.height
			? props.width
			: props.width
				? props.width
				: props.height
					? props.height
					: DEFAULT_WIDTH;
	const height =
		props.width && props.height
			? props.height
			: props.height
				? props.height
				: props.width
					? props.width
					: DEFAULT_HEIGHT;
	const color = props.color ? props.color : theme.palette.primary.main;

	const derivedProps = Object.assign({}, props);
	derivedProps.width = width;
	derivedProps.height = height;
	derivedProps.color = color;

	// if (props.tag) {
	// 	let normalizedTag = props.tag.trim();

	// 	if (icons[normalizedTag]) {
	// 		// Normal icon lookup via tag identifier.
	// 		const Icon = icons[normalizedTag];
	// 		return <Icon {...derivedProps} />;
	// 	} else {
	// 		// Second attempt to lookup correct icon (checking for known variants).
	// 		if (normalizedTag.endsWith('Basic') || normalizedTag.endsWith('basic')) {
	// 			normalizedTag = normalizedTag.substr(0, normalizedTag.length - 5).trim();
	// 		} else if (normalizedTag.endsWith('Beginner') || normalizedTag.endsWith('beginner')) {
	// 			normalizedTag = normalizedTag.substr(0, normalizedTag.length - 8).trim();
	// 		} else if (normalizedTag.endsWith('Intermediate') || normalizedTag.endsWith('intermediate')) {
	// 			normalizedTag = normalizedTag.substr(0, normalizedTag.length - 12).trim();
	// 		} else if (normalizedTag.endsWith('Advanced') || normalizedTag.endsWith('advanced')) {
	// 			normalizedTag = normalizedTag.substr(0, normalizedTag.length - 8).trim();
	// 		}

	// 		if (icons[normalizedTag]) {
	// 			const Icon = icons[normalizedTag];
	// 			return <Icon {...derivedProps} />;
	// 		} else {
	// 			// Final attempt to lookup correct icon (loose comparision check for icon identifier inside supplied tag).
	// 			Object.keys(icons).forEach(iconIdentifier => {
	// 				if (normalizedTag.toLowerCase().includes(iconIdentifier.toLowerCase())) {
	// 					normalizedTag = iconIdentifier;
	// 				}
	// 			});
	// 			if (icons[normalizedTag]) {
	// 				const Icon = icons[normalizedTag];
	// 				return <Icon {...derivedProps} />;
	// 			}
	// 		}
	// 	}
	// }

	// return <FaGraduationCap  size={derivedProps.height} color={derivedProps.color}/>;
	if (record?.iconUrl && record?.iconUrl.trim().length > 0) {
		return (
			<img
			  alt={'skillicon'}
				src={record.iconUrl}
				style={{
					height: props.width,
					width: props.height,
					backgroundColor: record.mainColour,
					borderRadius: '10%',
				}}
			/>
		)
	} else {
		return (
			<div
				style={{
					flex: '0 0 auto',
					display: 'flex',
					width: props.height,
					height: props.width,
					borderRadius: '10%',
					overflow: 'hidden',
				}}
			>
				<svg
					width={'100%'}
					height={'100%'}
					viewBox={'0 0 40 40'}
					xmlns='http://www.w3.org/2000/svg'
					version='1.1'
					style={{
						pointerEvents: 'none',
						backgroundColor: record?.mainColour
							? record.mainColour
							: 'rgb(42, 44, 60)',
					}}
				>
					<text
						textAnchor='middle'
						alignmentBaseline='middle'
						x={40 * 0.5}
						y={40 * 0.55}
						style={{
							fontFamily: 'Arial',
							fontWeight: 'bold',
							fill: '#ffffff',
							stroke: '#ffffff',
							fontSize: '24px',
						}}
					>
						{record?.displayShortName ? record.displayShortName : 'Sk'}
					</text>
				</svg>
			</div>
		)
	}
}

export default SkillIcon;
